/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SessionRouteRouteImport } from './routes/session/route'
import { Route as AppRouteRouteImport } from './routes/app/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SessionIndexRouteImport } from './routes/session/index'
import { Route as AppIndexRouteImport } from './routes/app/index'
import { Route as SessionPasswordResetRouteRouteImport } from './routes/session/password-reset/route'
import { Route as AppUsersRouteRouteImport } from './routes/app/users/route'
import { Route as AppSettingsRouteRouteImport } from './routes/app/settings/route'
import { Route as AppNotificationsRouteRouteImport } from './routes/app/notifications/route'
import { Route as AppDataRouteRouteImport } from './routes/app/data/route'
import { Route as AppDashboardRouteRouteImport } from './routes/app/dashboard/route'
import { Route as AppAnalysisRouteRouteImport } from './routes/app/analysis/route'
import { Route as SessionPasswordResetIndexRouteImport } from './routes/session/password-reset/index'
import { Route as SessionLoginIndexRouteImport } from './routes/session/login/index'
import { Route as AppSettingsIndexRouteImport } from './routes/app/settings/index'
import { Route as AppDataIndexRouteImport } from './routes/app/data/index'
import { Route as SessionPasswordResetLinkSentRouteImport } from './routes/session/password-reset/link-sent'
import { Route as AppSettingsImportRunsRouteRouteImport } from './routes/app/settings/import-runs/route'
import { Route as AppSettingsFileTypesRouteRouteImport } from './routes/app/settings/file-types/route'
import { Route as AppDataPoliciesRouteRouteImport } from './routes/app/data/policies/route'
import { Route as AppDataInsistencesRouteRouteImport } from './routes/app/data/insistences/route'
import { Route as AppDataGroupsRouteRouteImport } from './routes/app/data/groups/route'
import { Route as AppDataCoveragesRouteRouteImport } from './routes/app/data/coverages/route'
import { Route as AppDashboardCoverageUuidRouteRouteImport } from './routes/app/dashboard/$coverageUuid/route'
import { Route as AppAnalysisCoveragesRouteRouteImport } from './routes/app/analysis/coverages/route'
import { Route as SessionPasswordResetTokenIndexRouteImport } from './routes/session/password-reset/$token/index'
import { Route as SessionLogin2faIndexRouteImport } from './routes/session/login/2fa/index'
import { Route as AppSettingsTrustedDevicesIndexRouteImport } from './routes/app/settings/trusted-devices/index'
import { Route as AppDataCompaniesIndexRouteImport } from './routes/app/data/companies/index'
import { Route as AppDashboardCoverageUuidIndexRouteImport } from './routes/app/dashboard/$coverageUuid/index'
import { Route as AppAnalysisPerformanceIndexRouteImport } from './routes/app/analysis/performance/index'
import { Route as AppAnalysisInsurersIndexRouteImport } from './routes/app/analysis/insurers/index'
import { Route as AppAnalysisExposuresIndexRouteImport } from './routes/app/analysis/exposures/index'
import { Route as AppDataPoliciesUuidRouteRouteImport } from './routes/app/data/policies/$uuid/route'
import { Route as AppDataInsistencesCoverageUuidRouteRouteImport } from './routes/app/data/insistences/$coverageUuid/route'
import { Route as AppDataGroupsUuidRouteRouteImport } from './routes/app/data/groups/$uuid/route'
import { Route as AppDataCoveragesUuidRouteRouteImport } from './routes/app/data/coverages/$uuid/route'
import { Route as AppDataCompaniesUuidRouteRouteImport } from './routes/app/data/companies/$uuid/route'
import { Route as AppAnalysisCoveragesUuidRouteRouteImport } from './routes/app/analysis/coverages/$uuid/route'
import { Route as AppDataPoliciesUuidIndexRouteImport } from './routes/app/data/policies/$uuid/index'
import { Route as AppDataInsistencesCoverageUuidIndexRouteImport } from './routes/app/data/insistences/$coverageUuid/index'
import { Route as AppDataGroupsUuidIndexRouteImport } from './routes/app/data/groups/$uuid/index'
import { Route as AppDataCoveragesUuidIndexRouteImport } from './routes/app/data/coverages/$uuid/index'
import { Route as AppAnalysisCoveragesUuidIndexRouteImport } from './routes/app/analysis/coverages/$uuid/index'
import { Route as AppDataCompaniesUuidEditRouteImport } from './routes/app/data/companies/$uuid/edit'
import { Route as AppDataCompaniesUuidmainPageRouteRouteImport } from './routes/app/data/companies/$uuid/(mainPage)/route'
import { Route as AppDataPoliciesUuidCoverageUuidIndexRouteImport } from './routes/app/data/policies/$uuid/$coverageUuid/index'
import { Route as AppDataGroupsUuidPolicyUuidIndexRouteImport } from './routes/app/data/groups/$uuid/$policyUuid/index'
import { Route as AppDataCompaniesUuidmainPageIndexRouteImport } from './routes/app/data/companies/$uuid/(mainPage)/index'
import { Route as AppDataCompaniesUuidmainPageInsuredRouteRouteImport } from './routes/app/data/companies/$uuid/(mainPage)/insured/route'
import { Route as AppDataCompaniesUuidmainPageDebtorRouteRouteImport } from './routes/app/data/companies/$uuid/(mainPage)/debtor/route'
import { Route as AppDataGroupsUuidCoverageCoverageUuidIndexRouteImport } from './routes/app/data/groups/$uuid/coverage.$coverageUuid/index'
import { Route as AppDataGroupsUuidPolicyUuidCoverageUuidIndexRouteImport } from './routes/app/data/groups/$uuid/$policyUuid/$coverageUuid/index'
import { Route as AppDataCompaniesUuidmainPageInsuredIndexRouteImport } from './routes/app/data/companies/$uuid/(mainPage)/insured/index'
import { Route as AppDataCompaniesUuidmainPageDebtorIndexRouteImport } from './routes/app/data/companies/$uuid/(mainPage)/debtor/index'
import { Route as AppDataCompaniesUuidmainPageInsuredPoliciesRouteRouteImport } from './routes/app/data/companies/$uuid/(mainPage)/insured/policies/route'
import { Route as AppDataCompaniesUuidmainPageInsuredInsistencesRouteRouteImport } from './routes/app/data/companies/$uuid/(mainPage)/insured/insistences/route'
import { Route as AppDataCompaniesUuidmainPageInsuredFilesRouteRouteImport } from './routes/app/data/companies/$uuid/(mainPage)/insured/files/route'
import { Route as AppDataCompaniesUuidmainPageInsuredCoveragesRouteRouteImport } from './routes/app/data/companies/$uuid/(mainPage)/insured/coverages/route'
import { Route as AppDataCompaniesUuidmainPageDebtorInsistencesRouteRouteImport } from './routes/app/data/companies/$uuid/(mainPage)/debtor/insistences/route'
import { Route as AppDataCompaniesUuidmainPageDebtorFilesRouteRouteImport } from './routes/app/data/companies/$uuid/(mainPage)/debtor/files/route'
import { Route as AppDataCompaniesUuidmainPageDebtorCoveragesRouteRouteImport } from './routes/app/data/companies/$uuid/(mainPage)/debtor/coverages/route'
import { Route as AppDataCompaniesUuidmainPageInsuredPoliciesPolicyUuidRouteRouteImport } from './routes/app/data/companies/$uuid/(mainPage)/insured/policies/$policyUuid/route'
import { Route as AppDataCompaniesUuidmainPageInsuredInsistencesCoverageUuidRouteRouteImport } from './routes/app/data/companies/$uuid/(mainPage)/insured/insistences/$coverageUuid/route'
import { Route as AppDataCompaniesUuidmainPageInsuredCoveragesCoverageUuidRouteRouteImport } from './routes/app/data/companies/$uuid/(mainPage)/insured/coverages/$coverageUuid/route'
import { Route as AppDataCompaniesUuidmainPageDebtorInsistencesCoverageUuidRouteRouteImport } from './routes/app/data/companies/$uuid/(mainPage)/debtor/insistences/$coverageUuid/route'
import { Route as AppDataCompaniesUuidmainPageDebtorCoveragesCoverageUuidRouteRouteImport } from './routes/app/data/companies/$uuid/(mainPage)/debtor/coverages/$coverageUuid/route'
import { Route as AppDataCompaniesUuidmainPageInsuredPoliciesPolicyUuidIndexRouteImport } from './routes/app/data/companies/$uuid/(mainPage)/insured/policies/$policyUuid/index'
import { Route as AppDataCompaniesUuidmainPageInsuredInsistencesCoverageUuidIndexRouteImport } from './routes/app/data/companies/$uuid/(mainPage)/insured/insistences/$coverageUuid/index'
import { Route as AppDataCompaniesUuidmainPageInsuredCoveragesCoverageUuidIndexRouteImport } from './routes/app/data/companies/$uuid/(mainPage)/insured/coverages/$coverageUuid/index'
import { Route as AppDataCompaniesUuidmainPageDebtorInsistencesCoverageUuidIndexRouteImport } from './routes/app/data/companies/$uuid/(mainPage)/debtor/insistences/$coverageUuid/index'
import { Route as AppDataCompaniesUuidmainPageDebtorCoveragesCoverageUuidIndexRouteImport } from './routes/app/data/companies/$uuid/(mainPage)/debtor/coverages/$coverageUuid/index'
import { Route as AppDataCompaniesUuidmainPageInsuredPoliciesPolicyUuidCoverageUuidIndexRouteImport } from './routes/app/data/companies/$uuid/(mainPage)/insured/policies/$policyUuid/$coverageUuid/index'

const SessionRouteRoute = SessionRouteRouteImport.update({
  id: '/session',
  path: '/session',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRouteRoute = AppRouteRouteImport.update({
  id: '/app',
  path: '/app',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SessionIndexRoute = SessionIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SessionRouteRoute,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRouteRoute,
} as any)
const SessionPasswordResetRouteRoute =
  SessionPasswordResetRouteRouteImport.update({
    id: '/password-reset',
    path: '/password-reset',
    getParentRoute: () => SessionRouteRoute,
  } as any)
const AppUsersRouteRoute = AppUsersRouteRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSettingsRouteRoute = AppSettingsRouteRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppNotificationsRouteRoute = AppNotificationsRouteRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppDataRouteRoute = AppDataRouteRouteImport.update({
  id: '/data',
  path: '/data',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppDashboardRouteRoute = AppDashboardRouteRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppAnalysisRouteRoute = AppAnalysisRouteRouteImport.update({
  id: '/analysis',
  path: '/analysis',
  getParentRoute: () => AppRouteRoute,
} as any)
const SessionPasswordResetIndexRoute =
  SessionPasswordResetIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SessionPasswordResetRouteRoute,
  } as any)
const SessionLoginIndexRoute = SessionLoginIndexRouteImport.update({
  id: '/login/',
  path: '/login/',
  getParentRoute: () => SessionRouteRoute,
} as any)
const AppSettingsIndexRoute = AppSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppDataIndexRoute = AppDataIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppDataRouteRoute,
} as any)
const SessionPasswordResetLinkSentRoute =
  SessionPasswordResetLinkSentRouteImport.update({
    id: '/link-sent',
    path: '/link-sent',
    getParentRoute: () => SessionPasswordResetRouteRoute,
  } as any)
const AppSettingsImportRunsRouteRoute =
  AppSettingsImportRunsRouteRouteImport.update({
    id: '/import-runs',
    path: '/import-runs',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsFileTypesRouteRoute =
  AppSettingsFileTypesRouteRouteImport.update({
    id: '/file-types',
    path: '/file-types',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppDataPoliciesRouteRoute = AppDataPoliciesRouteRouteImport.update({
  id: '/policies',
  path: '/policies',
  getParentRoute: () => AppDataRouteRoute,
} as any)
const AppDataInsistencesRouteRoute = AppDataInsistencesRouteRouteImport.update({
  id: '/insistences',
  path: '/insistences',
  getParentRoute: () => AppDataRouteRoute,
} as any)
const AppDataGroupsRouteRoute = AppDataGroupsRouteRouteImport.update({
  id: '/groups',
  path: '/groups',
  getParentRoute: () => AppDataRouteRoute,
} as any)
const AppDataCoveragesRouteRoute = AppDataCoveragesRouteRouteImport.update({
  id: '/coverages',
  path: '/coverages',
  getParentRoute: () => AppDataRouteRoute,
} as any)
const AppDashboardCoverageUuidRouteRoute =
  AppDashboardCoverageUuidRouteRouteImport.update({
    id: '/$coverageUuid',
    path: '/$coverageUuid',
    getParentRoute: () => AppDashboardRouteRoute,
  } as any)
const AppAnalysisCoveragesRouteRoute =
  AppAnalysisCoveragesRouteRouteImport.update({
    id: '/coverages',
    path: '/coverages',
    getParentRoute: () => AppAnalysisRouteRoute,
  } as any)
const SessionPasswordResetTokenIndexRoute =
  SessionPasswordResetTokenIndexRouteImport.update({
    id: '/$token/',
    path: '/$token/',
    getParentRoute: () => SessionPasswordResetRouteRoute,
  } as any)
const SessionLogin2faIndexRoute = SessionLogin2faIndexRouteImport.update({
  id: '/login/2fa/',
  path: '/login/2fa/',
  getParentRoute: () => SessionRouteRoute,
} as any)
const AppSettingsTrustedDevicesIndexRoute =
  AppSettingsTrustedDevicesIndexRouteImport.update({
    id: '/trusted-devices/',
    path: '/trusted-devices/',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppDataCompaniesIndexRoute = AppDataCompaniesIndexRouteImport.update({
  id: '/companies/',
  path: '/companies/',
  getParentRoute: () => AppDataRouteRoute,
} as any)
const AppDashboardCoverageUuidIndexRoute =
  AppDashboardCoverageUuidIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppDashboardCoverageUuidRouteRoute,
  } as any)
const AppAnalysisPerformanceIndexRoute =
  AppAnalysisPerformanceIndexRouteImport.update({
    id: '/performance/',
    path: '/performance/',
    getParentRoute: () => AppAnalysisRouteRoute,
  } as any)
const AppAnalysisInsurersIndexRoute =
  AppAnalysisInsurersIndexRouteImport.update({
    id: '/insurers/',
    path: '/insurers/',
    getParentRoute: () => AppAnalysisRouteRoute,
  } as any)
const AppAnalysisExposuresIndexRoute =
  AppAnalysisExposuresIndexRouteImport.update({
    id: '/exposures/',
    path: '/exposures/',
    getParentRoute: () => AppAnalysisRouteRoute,
  } as any)
const AppDataPoliciesUuidRouteRoute =
  AppDataPoliciesUuidRouteRouteImport.update({
    id: '/$uuid',
    path: '/$uuid',
    getParentRoute: () => AppDataPoliciesRouteRoute,
  } as any)
const AppDataInsistencesCoverageUuidRouteRoute =
  AppDataInsistencesCoverageUuidRouteRouteImport.update({
    id: '/$coverageUuid',
    path: '/$coverageUuid',
    getParentRoute: () => AppDataInsistencesRouteRoute,
  } as any)
const AppDataGroupsUuidRouteRoute = AppDataGroupsUuidRouteRouteImport.update({
  id: '/$uuid',
  path: '/$uuid',
  getParentRoute: () => AppDataGroupsRouteRoute,
} as any)
const AppDataCoveragesUuidRouteRoute =
  AppDataCoveragesUuidRouteRouteImport.update({
    id: '/$uuid',
    path: '/$uuid',
    getParentRoute: () => AppDataCoveragesRouteRoute,
  } as any)
const AppDataCompaniesUuidRouteRoute =
  AppDataCompaniesUuidRouteRouteImport.update({
    id: '/companies/$uuid',
    path: '/companies/$uuid',
    getParentRoute: () => AppDataRouteRoute,
  } as any)
const AppAnalysisCoveragesUuidRouteRoute =
  AppAnalysisCoveragesUuidRouteRouteImport.update({
    id: '/$uuid',
    path: '/$uuid',
    getParentRoute: () => AppAnalysisCoveragesRouteRoute,
  } as any)
const AppDataPoliciesUuidIndexRoute =
  AppDataPoliciesUuidIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppDataPoliciesUuidRouteRoute,
  } as any)
const AppDataInsistencesCoverageUuidIndexRoute =
  AppDataInsistencesCoverageUuidIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppDataInsistencesCoverageUuidRouteRoute,
  } as any)
const AppDataGroupsUuidIndexRoute = AppDataGroupsUuidIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppDataGroupsUuidRouteRoute,
} as any)
const AppDataCoveragesUuidIndexRoute =
  AppDataCoveragesUuidIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppDataCoveragesUuidRouteRoute,
  } as any)
const AppAnalysisCoveragesUuidIndexRoute =
  AppAnalysisCoveragesUuidIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppAnalysisCoveragesUuidRouteRoute,
  } as any)
const AppDataCompaniesUuidEditRoute =
  AppDataCompaniesUuidEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AppDataCompaniesUuidRouteRoute,
  } as any)
const AppDataCompaniesUuidmainPageRouteRoute =
  AppDataCompaniesUuidmainPageRouteRouteImport.update({
    id: '/(mainPage)',
    getParentRoute: () => AppDataCompaniesUuidRouteRoute,
  } as any)
const AppDataPoliciesUuidCoverageUuidIndexRoute =
  AppDataPoliciesUuidCoverageUuidIndexRouteImport.update({
    id: '/$coverageUuid/',
    path: '/$coverageUuid/',
    getParentRoute: () => AppDataPoliciesUuidRouteRoute,
  } as any)
const AppDataGroupsUuidPolicyUuidIndexRoute =
  AppDataGroupsUuidPolicyUuidIndexRouteImport.update({
    id: '/$policyUuid/',
    path: '/$policyUuid/',
    getParentRoute: () => AppDataGroupsUuidRouteRoute,
  } as any)
const AppDataCompaniesUuidmainPageIndexRoute =
  AppDataCompaniesUuidmainPageIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppDataCompaniesUuidmainPageRouteRoute,
  } as any)
const AppDataCompaniesUuidmainPageInsuredRouteRoute =
  AppDataCompaniesUuidmainPageInsuredRouteRouteImport.update({
    id: '/insured',
    path: '/insured',
    getParentRoute: () => AppDataCompaniesUuidmainPageRouteRoute,
  } as any)
const AppDataCompaniesUuidmainPageDebtorRouteRoute =
  AppDataCompaniesUuidmainPageDebtorRouteRouteImport.update({
    id: '/debtor',
    path: '/debtor',
    getParentRoute: () => AppDataCompaniesUuidmainPageRouteRoute,
  } as any)
const AppDataGroupsUuidCoverageCoverageUuidIndexRoute =
  AppDataGroupsUuidCoverageCoverageUuidIndexRouteImport.update({
    id: '/coverage/$coverageUuid/',
    path: '/coverage/$coverageUuid/',
    getParentRoute: () => AppDataGroupsUuidRouteRoute,
  } as any)
const AppDataGroupsUuidPolicyUuidCoverageUuidIndexRoute =
  AppDataGroupsUuidPolicyUuidCoverageUuidIndexRouteImport.update({
    id: '/$policyUuid/$coverageUuid/',
    path: '/$policyUuid/$coverageUuid/',
    getParentRoute: () => AppDataGroupsUuidRouteRoute,
  } as any)
const AppDataCompaniesUuidmainPageInsuredIndexRoute =
  AppDataCompaniesUuidmainPageInsuredIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppDataCompaniesUuidmainPageInsuredRouteRoute,
  } as any)
const AppDataCompaniesUuidmainPageDebtorIndexRoute =
  AppDataCompaniesUuidmainPageDebtorIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppDataCompaniesUuidmainPageDebtorRouteRoute,
  } as any)
const AppDataCompaniesUuidmainPageInsuredPoliciesRouteRoute =
  AppDataCompaniesUuidmainPageInsuredPoliciesRouteRouteImport.update({
    id: '/policies',
    path: '/policies',
    getParentRoute: () => AppDataCompaniesUuidmainPageInsuredRouteRoute,
  } as any)
const AppDataCompaniesUuidmainPageInsuredInsistencesRouteRoute =
  AppDataCompaniesUuidmainPageInsuredInsistencesRouteRouteImport.update({
    id: '/insistences',
    path: '/insistences',
    getParentRoute: () => AppDataCompaniesUuidmainPageInsuredRouteRoute,
  } as any)
const AppDataCompaniesUuidmainPageInsuredFilesRouteRoute =
  AppDataCompaniesUuidmainPageInsuredFilesRouteRouteImport.update({
    id: '/files',
    path: '/files',
    getParentRoute: () => AppDataCompaniesUuidmainPageInsuredRouteRoute,
  } as any)
const AppDataCompaniesUuidmainPageInsuredCoveragesRouteRoute =
  AppDataCompaniesUuidmainPageInsuredCoveragesRouteRouteImport.update({
    id: '/coverages',
    path: '/coverages',
    getParentRoute: () => AppDataCompaniesUuidmainPageInsuredRouteRoute,
  } as any)
const AppDataCompaniesUuidmainPageDebtorInsistencesRouteRoute =
  AppDataCompaniesUuidmainPageDebtorInsistencesRouteRouteImport.update({
    id: '/insistences',
    path: '/insistences',
    getParentRoute: () => AppDataCompaniesUuidmainPageDebtorRouteRoute,
  } as any)
const AppDataCompaniesUuidmainPageDebtorFilesRouteRoute =
  AppDataCompaniesUuidmainPageDebtorFilesRouteRouteImport.update({
    id: '/files',
    path: '/files',
    getParentRoute: () => AppDataCompaniesUuidmainPageDebtorRouteRoute,
  } as any)
const AppDataCompaniesUuidmainPageDebtorCoveragesRouteRoute =
  AppDataCompaniesUuidmainPageDebtorCoveragesRouteRouteImport.update({
    id: '/coverages',
    path: '/coverages',
    getParentRoute: () => AppDataCompaniesUuidmainPageDebtorRouteRoute,
  } as any)
const AppDataCompaniesUuidmainPageInsuredPoliciesPolicyUuidRouteRoute =
  AppDataCompaniesUuidmainPageInsuredPoliciesPolicyUuidRouteRouteImport.update({
    id: '/$policyUuid',
    path: '/$policyUuid',
    getParentRoute: () => AppDataCompaniesUuidmainPageInsuredPoliciesRouteRoute,
  } as any)
const AppDataCompaniesUuidmainPageInsuredInsistencesCoverageUuidRouteRoute =
  AppDataCompaniesUuidmainPageInsuredInsistencesCoverageUuidRouteRouteImport.update(
    {
      id: '/$coverageUuid',
      path: '/$coverageUuid',
      getParentRoute: () =>
        AppDataCompaniesUuidmainPageInsuredInsistencesRouteRoute,
    } as any,
  )
const AppDataCompaniesUuidmainPageInsuredCoveragesCoverageUuidRouteRoute =
  AppDataCompaniesUuidmainPageInsuredCoveragesCoverageUuidRouteRouteImport.update(
    {
      id: '/$coverageUuid',
      path: '/$coverageUuid',
      getParentRoute: () =>
        AppDataCompaniesUuidmainPageInsuredCoveragesRouteRoute,
    } as any,
  )
const AppDataCompaniesUuidmainPageDebtorInsistencesCoverageUuidRouteRoute =
  AppDataCompaniesUuidmainPageDebtorInsistencesCoverageUuidRouteRouteImport.update(
    {
      id: '/$coverageUuid',
      path: '/$coverageUuid',
      getParentRoute: () =>
        AppDataCompaniesUuidmainPageDebtorInsistencesRouteRoute,
    } as any,
  )
const AppDataCompaniesUuidmainPageDebtorCoveragesCoverageUuidRouteRoute =
  AppDataCompaniesUuidmainPageDebtorCoveragesCoverageUuidRouteRouteImport.update(
    {
      id: '/$coverageUuid',
      path: '/$coverageUuid',
      getParentRoute: () =>
        AppDataCompaniesUuidmainPageDebtorCoveragesRouteRoute,
    } as any,
  )
const AppDataCompaniesUuidmainPageInsuredPoliciesPolicyUuidIndexRoute =
  AppDataCompaniesUuidmainPageInsuredPoliciesPolicyUuidIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AppDataCompaniesUuidmainPageInsuredPoliciesPolicyUuidRouteRoute,
  } as any)
const AppDataCompaniesUuidmainPageInsuredInsistencesCoverageUuidIndexRoute =
  AppDataCompaniesUuidmainPageInsuredInsistencesCoverageUuidIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppDataCompaniesUuidmainPageInsuredInsistencesCoverageUuidRouteRoute,
    } as any,
  )
const AppDataCompaniesUuidmainPageInsuredCoveragesCoverageUuidIndexRoute =
  AppDataCompaniesUuidmainPageInsuredCoveragesCoverageUuidIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppDataCompaniesUuidmainPageInsuredCoveragesCoverageUuidRouteRoute,
    } as any,
  )
const AppDataCompaniesUuidmainPageDebtorInsistencesCoverageUuidIndexRoute =
  AppDataCompaniesUuidmainPageDebtorInsistencesCoverageUuidIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppDataCompaniesUuidmainPageDebtorInsistencesCoverageUuidRouteRoute,
    } as any,
  )
const AppDataCompaniesUuidmainPageDebtorCoveragesCoverageUuidIndexRoute =
  AppDataCompaniesUuidmainPageDebtorCoveragesCoverageUuidIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppDataCompaniesUuidmainPageDebtorCoveragesCoverageUuidRouteRoute,
    } as any,
  )
const AppDataCompaniesUuidmainPageInsuredPoliciesPolicyUuidCoverageUuidIndexRoute =
  AppDataCompaniesUuidmainPageInsuredPoliciesPolicyUuidCoverageUuidIndexRouteImport.update(
    {
      id: '/$coverageUuid/',
      path: '/$coverageUuid/',
      getParentRoute: () =>
        AppDataCompaniesUuidmainPageInsuredPoliciesPolicyUuidRouteRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/app': typeof AppRouteRouteWithChildren
  '/session': typeof SessionRouteRouteWithChildren
  '/app/analysis': typeof AppAnalysisRouteRouteWithChildren
  '/app/dashboard': typeof AppDashboardRouteRouteWithChildren
  '/app/data': typeof AppDataRouteRouteWithChildren
  '/app/notifications': typeof AppNotificationsRouteRoute
  '/app/settings': typeof AppSettingsRouteRouteWithChildren
  '/app/users': typeof AppUsersRouteRoute
  '/session/password-reset': typeof SessionPasswordResetRouteRouteWithChildren
  '/app/': typeof AppIndexRoute
  '/session/': typeof SessionIndexRoute
  '/app/analysis/coverages': typeof AppAnalysisCoveragesRouteRouteWithChildren
  '/app/dashboard/$coverageUuid': typeof AppDashboardCoverageUuidRouteRouteWithChildren
  '/app/data/coverages': typeof AppDataCoveragesRouteRouteWithChildren
  '/app/data/groups': typeof AppDataGroupsRouteRouteWithChildren
  '/app/data/insistences': typeof AppDataInsistencesRouteRouteWithChildren
  '/app/data/policies': typeof AppDataPoliciesRouteRouteWithChildren
  '/app/settings/file-types': typeof AppSettingsFileTypesRouteRoute
  '/app/settings/import-runs': typeof AppSettingsImportRunsRouteRoute
  '/session/password-reset/link-sent': typeof SessionPasswordResetLinkSentRoute
  '/app/data/': typeof AppDataIndexRoute
  '/app/settings/': typeof AppSettingsIndexRoute
  '/session/login': typeof SessionLoginIndexRoute
  '/session/password-reset/': typeof SessionPasswordResetIndexRoute
  '/app/analysis/coverages/$uuid': typeof AppAnalysisCoveragesUuidRouteRouteWithChildren
  '/app/data/companies/$uuid': typeof AppDataCompaniesUuidmainPageRouteRouteWithChildren
  '/app/data/coverages/$uuid': typeof AppDataCoveragesUuidRouteRouteWithChildren
  '/app/data/groups/$uuid': typeof AppDataGroupsUuidRouteRouteWithChildren
  '/app/data/insistences/$coverageUuid': typeof AppDataInsistencesCoverageUuidRouteRouteWithChildren
  '/app/data/policies/$uuid': typeof AppDataPoliciesUuidRouteRouteWithChildren
  '/app/analysis/exposures': typeof AppAnalysisExposuresIndexRoute
  '/app/analysis/insurers': typeof AppAnalysisInsurersIndexRoute
  '/app/analysis/performance': typeof AppAnalysisPerformanceIndexRoute
  '/app/dashboard/$coverageUuid/': typeof AppDashboardCoverageUuidIndexRoute
  '/app/data/companies': typeof AppDataCompaniesIndexRoute
  '/app/settings/trusted-devices': typeof AppSettingsTrustedDevicesIndexRoute
  '/session/login/2fa': typeof SessionLogin2faIndexRoute
  '/session/password-reset/$token': typeof SessionPasswordResetTokenIndexRoute
  '/app/data/companies/$uuid/edit': typeof AppDataCompaniesUuidEditRoute
  '/app/analysis/coverages/$uuid/': typeof AppAnalysisCoveragesUuidIndexRoute
  '/app/data/coverages/$uuid/': typeof AppDataCoveragesUuidIndexRoute
  '/app/data/groups/$uuid/': typeof AppDataGroupsUuidIndexRoute
  '/app/data/insistences/$coverageUuid/': typeof AppDataInsistencesCoverageUuidIndexRoute
  '/app/data/policies/$uuid/': typeof AppDataPoliciesUuidIndexRoute
  '/app/data/companies/$uuid/debtor': typeof AppDataCompaniesUuidmainPageDebtorRouteRouteWithChildren
  '/app/data/companies/$uuid/insured': typeof AppDataCompaniesUuidmainPageInsuredRouteRouteWithChildren
  '/app/data/companies/$uuid/': typeof AppDataCompaniesUuidmainPageIndexRoute
  '/app/data/groups/$uuid/$policyUuid': typeof AppDataGroupsUuidPolicyUuidIndexRoute
  '/app/data/policies/$uuid/$coverageUuid': typeof AppDataPoliciesUuidCoverageUuidIndexRoute
  '/app/data/companies/$uuid/debtor/coverages': typeof AppDataCompaniesUuidmainPageDebtorCoveragesRouteRouteWithChildren
  '/app/data/companies/$uuid/debtor/files': typeof AppDataCompaniesUuidmainPageDebtorFilesRouteRoute
  '/app/data/companies/$uuid/debtor/insistences': typeof AppDataCompaniesUuidmainPageDebtorInsistencesRouteRouteWithChildren
  '/app/data/companies/$uuid/insured/coverages': typeof AppDataCompaniesUuidmainPageInsuredCoveragesRouteRouteWithChildren
  '/app/data/companies/$uuid/insured/files': typeof AppDataCompaniesUuidmainPageInsuredFilesRouteRoute
  '/app/data/companies/$uuid/insured/insistences': typeof AppDataCompaniesUuidmainPageInsuredInsistencesRouteRouteWithChildren
  '/app/data/companies/$uuid/insured/policies': typeof AppDataCompaniesUuidmainPageInsuredPoliciesRouteRouteWithChildren
  '/app/data/companies/$uuid/debtor/': typeof AppDataCompaniesUuidmainPageDebtorIndexRoute
  '/app/data/companies/$uuid/insured/': typeof AppDataCompaniesUuidmainPageInsuredIndexRoute
  '/app/data/groups/$uuid/$policyUuid/$coverageUuid': typeof AppDataGroupsUuidPolicyUuidCoverageUuidIndexRoute
  '/app/data/groups/$uuid/coverage/$coverageUuid': typeof AppDataGroupsUuidCoverageCoverageUuidIndexRoute
  '/app/data/companies/$uuid/debtor/coverages/$coverageUuid': typeof AppDataCompaniesUuidmainPageDebtorCoveragesCoverageUuidRouteRouteWithChildren
  '/app/data/companies/$uuid/debtor/insistences/$coverageUuid': typeof AppDataCompaniesUuidmainPageDebtorInsistencesCoverageUuidRouteRouteWithChildren
  '/app/data/companies/$uuid/insured/coverages/$coverageUuid': typeof AppDataCompaniesUuidmainPageInsuredCoveragesCoverageUuidRouteRouteWithChildren
  '/app/data/companies/$uuid/insured/insistences/$coverageUuid': typeof AppDataCompaniesUuidmainPageInsuredInsistencesCoverageUuidRouteRouteWithChildren
  '/app/data/companies/$uuid/insured/policies/$policyUuid': typeof AppDataCompaniesUuidmainPageInsuredPoliciesPolicyUuidRouteRouteWithChildren
  '/app/data/companies/$uuid/debtor/coverages/$coverageUuid/': typeof AppDataCompaniesUuidmainPageDebtorCoveragesCoverageUuidIndexRoute
  '/app/data/companies/$uuid/debtor/insistences/$coverageUuid/': typeof AppDataCompaniesUuidmainPageDebtorInsistencesCoverageUuidIndexRoute
  '/app/data/companies/$uuid/insured/coverages/$coverageUuid/': typeof AppDataCompaniesUuidmainPageInsuredCoveragesCoverageUuidIndexRoute
  '/app/data/companies/$uuid/insured/insistences/$coverageUuid/': typeof AppDataCompaniesUuidmainPageInsuredInsistencesCoverageUuidIndexRoute
  '/app/data/companies/$uuid/insured/policies/$policyUuid/': typeof AppDataCompaniesUuidmainPageInsuredPoliciesPolicyUuidIndexRoute
  '/app/data/companies/$uuid/insured/policies/$policyUuid/$coverageUuid': typeof AppDataCompaniesUuidmainPageInsuredPoliciesPolicyUuidCoverageUuidIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/app/analysis': typeof AppAnalysisRouteRouteWithChildren
  '/app/dashboard': typeof AppDashboardRouteRouteWithChildren
  '/app/notifications': typeof AppNotificationsRouteRoute
  '/app/users': typeof AppUsersRouteRoute
  '/app': typeof AppIndexRoute
  '/session': typeof SessionIndexRoute
  '/app/analysis/coverages': typeof AppAnalysisCoveragesRouteRouteWithChildren
  '/app/data/coverages': typeof AppDataCoveragesRouteRouteWithChildren
  '/app/data/groups': typeof AppDataGroupsRouteRouteWithChildren
  '/app/data/insistences': typeof AppDataInsistencesRouteRouteWithChildren
  '/app/data/policies': typeof AppDataPoliciesRouteRouteWithChildren
  '/app/settings/file-types': typeof AppSettingsFileTypesRouteRoute
  '/app/settings/import-runs': typeof AppSettingsImportRunsRouteRoute
  '/session/password-reset/link-sent': typeof SessionPasswordResetLinkSentRoute
  '/app/data': typeof AppDataIndexRoute
  '/app/settings': typeof AppSettingsIndexRoute
  '/session/login': typeof SessionLoginIndexRoute
  '/session/password-reset': typeof SessionPasswordResetIndexRoute
  '/app/data/companies/$uuid': typeof AppDataCompaniesUuidmainPageIndexRoute
  '/app/analysis/exposures': typeof AppAnalysisExposuresIndexRoute
  '/app/analysis/insurers': typeof AppAnalysisInsurersIndexRoute
  '/app/analysis/performance': typeof AppAnalysisPerformanceIndexRoute
  '/app/dashboard/$coverageUuid': typeof AppDashboardCoverageUuidIndexRoute
  '/app/data/companies': typeof AppDataCompaniesIndexRoute
  '/app/settings/trusted-devices': typeof AppSettingsTrustedDevicesIndexRoute
  '/session/login/2fa': typeof SessionLogin2faIndexRoute
  '/session/password-reset/$token': typeof SessionPasswordResetTokenIndexRoute
  '/app/data/companies/$uuid/edit': typeof AppDataCompaniesUuidEditRoute
  '/app/analysis/coverages/$uuid': typeof AppAnalysisCoveragesUuidIndexRoute
  '/app/data/coverages/$uuid': typeof AppDataCoveragesUuidIndexRoute
  '/app/data/groups/$uuid': typeof AppDataGroupsUuidIndexRoute
  '/app/data/insistences/$coverageUuid': typeof AppDataInsistencesCoverageUuidIndexRoute
  '/app/data/policies/$uuid': typeof AppDataPoliciesUuidIndexRoute
  '/app/data/groups/$uuid/$policyUuid': typeof AppDataGroupsUuidPolicyUuidIndexRoute
  '/app/data/policies/$uuid/$coverageUuid': typeof AppDataPoliciesUuidCoverageUuidIndexRoute
  '/app/data/companies/$uuid/debtor/coverages': typeof AppDataCompaniesUuidmainPageDebtorCoveragesRouteRouteWithChildren
  '/app/data/companies/$uuid/debtor/files': typeof AppDataCompaniesUuidmainPageDebtorFilesRouteRoute
  '/app/data/companies/$uuid/debtor/insistences': typeof AppDataCompaniesUuidmainPageDebtorInsistencesRouteRouteWithChildren
  '/app/data/companies/$uuid/insured/coverages': typeof AppDataCompaniesUuidmainPageInsuredCoveragesRouteRouteWithChildren
  '/app/data/companies/$uuid/insured/files': typeof AppDataCompaniesUuidmainPageInsuredFilesRouteRoute
  '/app/data/companies/$uuid/insured/insistences': typeof AppDataCompaniesUuidmainPageInsuredInsistencesRouteRouteWithChildren
  '/app/data/companies/$uuid/insured/policies': typeof AppDataCompaniesUuidmainPageInsuredPoliciesRouteRouteWithChildren
  '/app/data/companies/$uuid/debtor': typeof AppDataCompaniesUuidmainPageDebtorIndexRoute
  '/app/data/companies/$uuid/insured': typeof AppDataCompaniesUuidmainPageInsuredIndexRoute
  '/app/data/groups/$uuid/$policyUuid/$coverageUuid': typeof AppDataGroupsUuidPolicyUuidCoverageUuidIndexRoute
  '/app/data/groups/$uuid/coverage/$coverageUuid': typeof AppDataGroupsUuidCoverageCoverageUuidIndexRoute
  '/app/data/companies/$uuid/debtor/coverages/$coverageUuid': typeof AppDataCompaniesUuidmainPageDebtorCoveragesCoverageUuidIndexRoute
  '/app/data/companies/$uuid/debtor/insistences/$coverageUuid': typeof AppDataCompaniesUuidmainPageDebtorInsistencesCoverageUuidIndexRoute
  '/app/data/companies/$uuid/insured/coverages/$coverageUuid': typeof AppDataCompaniesUuidmainPageInsuredCoveragesCoverageUuidIndexRoute
  '/app/data/companies/$uuid/insured/insistences/$coverageUuid': typeof AppDataCompaniesUuidmainPageInsuredInsistencesCoverageUuidIndexRoute
  '/app/data/companies/$uuid/insured/policies/$policyUuid': typeof AppDataCompaniesUuidmainPageInsuredPoliciesPolicyUuidIndexRoute
  '/app/data/companies/$uuid/insured/policies/$policyUuid/$coverageUuid': typeof AppDataCompaniesUuidmainPageInsuredPoliciesPolicyUuidCoverageUuidIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/app': typeof AppRouteRouteWithChildren
  '/session': typeof SessionRouteRouteWithChildren
  '/app/analysis': typeof AppAnalysisRouteRouteWithChildren
  '/app/dashboard': typeof AppDashboardRouteRouteWithChildren
  '/app/data': typeof AppDataRouteRouteWithChildren
  '/app/notifications': typeof AppNotificationsRouteRoute
  '/app/settings': typeof AppSettingsRouteRouteWithChildren
  '/app/users': typeof AppUsersRouteRoute
  '/session/password-reset': typeof SessionPasswordResetRouteRouteWithChildren
  '/app/': typeof AppIndexRoute
  '/session/': typeof SessionIndexRoute
  '/app/analysis/coverages': typeof AppAnalysisCoveragesRouteRouteWithChildren
  '/app/dashboard/$coverageUuid': typeof AppDashboardCoverageUuidRouteRouteWithChildren
  '/app/data/coverages': typeof AppDataCoveragesRouteRouteWithChildren
  '/app/data/groups': typeof AppDataGroupsRouteRouteWithChildren
  '/app/data/insistences': typeof AppDataInsistencesRouteRouteWithChildren
  '/app/data/policies': typeof AppDataPoliciesRouteRouteWithChildren
  '/app/settings/file-types': typeof AppSettingsFileTypesRouteRoute
  '/app/settings/import-runs': typeof AppSettingsImportRunsRouteRoute
  '/session/password-reset/link-sent': typeof SessionPasswordResetLinkSentRoute
  '/app/data/': typeof AppDataIndexRoute
  '/app/settings/': typeof AppSettingsIndexRoute
  '/session/login/': typeof SessionLoginIndexRoute
  '/session/password-reset/': typeof SessionPasswordResetIndexRoute
  '/app/analysis/coverages/$uuid': typeof AppAnalysisCoveragesUuidRouteRouteWithChildren
  '/app/data/companies/$uuid': typeof AppDataCompaniesUuidRouteRouteWithChildren
  '/app/data/coverages/$uuid': typeof AppDataCoveragesUuidRouteRouteWithChildren
  '/app/data/groups/$uuid': typeof AppDataGroupsUuidRouteRouteWithChildren
  '/app/data/insistences/$coverageUuid': typeof AppDataInsistencesCoverageUuidRouteRouteWithChildren
  '/app/data/policies/$uuid': typeof AppDataPoliciesUuidRouteRouteWithChildren
  '/app/analysis/exposures/': typeof AppAnalysisExposuresIndexRoute
  '/app/analysis/insurers/': typeof AppAnalysisInsurersIndexRoute
  '/app/analysis/performance/': typeof AppAnalysisPerformanceIndexRoute
  '/app/dashboard/$coverageUuid/': typeof AppDashboardCoverageUuidIndexRoute
  '/app/data/companies/': typeof AppDataCompaniesIndexRoute
  '/app/settings/trusted-devices/': typeof AppSettingsTrustedDevicesIndexRoute
  '/session/login/2fa/': typeof SessionLogin2faIndexRoute
  '/session/password-reset/$token/': typeof SessionPasswordResetTokenIndexRoute
  '/app/data/companies/$uuid/(mainPage)': typeof AppDataCompaniesUuidmainPageRouteRouteWithChildren
  '/app/data/companies/$uuid/edit': typeof AppDataCompaniesUuidEditRoute
  '/app/analysis/coverages/$uuid/': typeof AppAnalysisCoveragesUuidIndexRoute
  '/app/data/coverages/$uuid/': typeof AppDataCoveragesUuidIndexRoute
  '/app/data/groups/$uuid/': typeof AppDataGroupsUuidIndexRoute
  '/app/data/insistences/$coverageUuid/': typeof AppDataInsistencesCoverageUuidIndexRoute
  '/app/data/policies/$uuid/': typeof AppDataPoliciesUuidIndexRoute
  '/app/data/companies/$uuid/(mainPage)/debtor': typeof AppDataCompaniesUuidmainPageDebtorRouteRouteWithChildren
  '/app/data/companies/$uuid/(mainPage)/insured': typeof AppDataCompaniesUuidmainPageInsuredRouteRouteWithChildren
  '/app/data/companies/$uuid/(mainPage)/': typeof AppDataCompaniesUuidmainPageIndexRoute
  '/app/data/groups/$uuid/$policyUuid/': typeof AppDataGroupsUuidPolicyUuidIndexRoute
  '/app/data/policies/$uuid/$coverageUuid/': typeof AppDataPoliciesUuidCoverageUuidIndexRoute
  '/app/data/companies/$uuid/(mainPage)/debtor/coverages': typeof AppDataCompaniesUuidmainPageDebtorCoveragesRouteRouteWithChildren
  '/app/data/companies/$uuid/(mainPage)/debtor/files': typeof AppDataCompaniesUuidmainPageDebtorFilesRouteRoute
  '/app/data/companies/$uuid/(mainPage)/debtor/insistences': typeof AppDataCompaniesUuidmainPageDebtorInsistencesRouteRouteWithChildren
  '/app/data/companies/$uuid/(mainPage)/insured/coverages': typeof AppDataCompaniesUuidmainPageInsuredCoveragesRouteRouteWithChildren
  '/app/data/companies/$uuid/(mainPage)/insured/files': typeof AppDataCompaniesUuidmainPageInsuredFilesRouteRoute
  '/app/data/companies/$uuid/(mainPage)/insured/insistences': typeof AppDataCompaniesUuidmainPageInsuredInsistencesRouteRouteWithChildren
  '/app/data/companies/$uuid/(mainPage)/insured/policies': typeof AppDataCompaniesUuidmainPageInsuredPoliciesRouteRouteWithChildren
  '/app/data/companies/$uuid/(mainPage)/debtor/': typeof AppDataCompaniesUuidmainPageDebtorIndexRoute
  '/app/data/companies/$uuid/(mainPage)/insured/': typeof AppDataCompaniesUuidmainPageInsuredIndexRoute
  '/app/data/groups/$uuid/$policyUuid/$coverageUuid/': typeof AppDataGroupsUuidPolicyUuidCoverageUuidIndexRoute
  '/app/data/groups/$uuid/coverage/$coverageUuid/': typeof AppDataGroupsUuidCoverageCoverageUuidIndexRoute
  '/app/data/companies/$uuid/(mainPage)/debtor/coverages/$coverageUuid': typeof AppDataCompaniesUuidmainPageDebtorCoveragesCoverageUuidRouteRouteWithChildren
  '/app/data/companies/$uuid/(mainPage)/debtor/insistences/$coverageUuid': typeof AppDataCompaniesUuidmainPageDebtorInsistencesCoverageUuidRouteRouteWithChildren
  '/app/data/companies/$uuid/(mainPage)/insured/coverages/$coverageUuid': typeof AppDataCompaniesUuidmainPageInsuredCoveragesCoverageUuidRouteRouteWithChildren
  '/app/data/companies/$uuid/(mainPage)/insured/insistences/$coverageUuid': typeof AppDataCompaniesUuidmainPageInsuredInsistencesCoverageUuidRouteRouteWithChildren
  '/app/data/companies/$uuid/(mainPage)/insured/policies/$policyUuid': typeof AppDataCompaniesUuidmainPageInsuredPoliciesPolicyUuidRouteRouteWithChildren
  '/app/data/companies/$uuid/(mainPage)/debtor/coverages/$coverageUuid/': typeof AppDataCompaniesUuidmainPageDebtorCoveragesCoverageUuidIndexRoute
  '/app/data/companies/$uuid/(mainPage)/debtor/insistences/$coverageUuid/': typeof AppDataCompaniesUuidmainPageDebtorInsistencesCoverageUuidIndexRoute
  '/app/data/companies/$uuid/(mainPage)/insured/coverages/$coverageUuid/': typeof AppDataCompaniesUuidmainPageInsuredCoveragesCoverageUuidIndexRoute
  '/app/data/companies/$uuid/(mainPage)/insured/insistences/$coverageUuid/': typeof AppDataCompaniesUuidmainPageInsuredInsistencesCoverageUuidIndexRoute
  '/app/data/companies/$uuid/(mainPage)/insured/policies/$policyUuid/': typeof AppDataCompaniesUuidmainPageInsuredPoliciesPolicyUuidIndexRoute
  '/app/data/companies/$uuid/(mainPage)/insured/policies/$policyUuid/$coverageUuid/': typeof AppDataCompaniesUuidmainPageInsuredPoliciesPolicyUuidCoverageUuidIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/app'
    | '/session'
    | '/app/analysis'
    | '/app/dashboard'
    | '/app/data'
    | '/app/notifications'
    | '/app/settings'
    | '/app/users'
    | '/session/password-reset'
    | '/app/'
    | '/session/'
    | '/app/analysis/coverages'
    | '/app/dashboard/$coverageUuid'
    | '/app/data/coverages'
    | '/app/data/groups'
    | '/app/data/insistences'
    | '/app/data/policies'
    | '/app/settings/file-types'
    | '/app/settings/import-runs'
    | '/session/password-reset/link-sent'
    | '/app/data/'
    | '/app/settings/'
    | '/session/login'
    | '/session/password-reset/'
    | '/app/analysis/coverages/$uuid'
    | '/app/data/companies/$uuid'
    | '/app/data/coverages/$uuid'
    | '/app/data/groups/$uuid'
    | '/app/data/insistences/$coverageUuid'
    | '/app/data/policies/$uuid'
    | '/app/analysis/exposures'
    | '/app/analysis/insurers'
    | '/app/analysis/performance'
    | '/app/dashboard/$coverageUuid/'
    | '/app/data/companies'
    | '/app/settings/trusted-devices'
    | '/session/login/2fa'
    | '/session/password-reset/$token'
    | '/app/data/companies/$uuid/edit'
    | '/app/analysis/coverages/$uuid/'
    | '/app/data/coverages/$uuid/'
    | '/app/data/groups/$uuid/'
    | '/app/data/insistences/$coverageUuid/'
    | '/app/data/policies/$uuid/'
    | '/app/data/companies/$uuid/debtor'
    | '/app/data/companies/$uuid/insured'
    | '/app/data/companies/$uuid/'
    | '/app/data/groups/$uuid/$policyUuid'
    | '/app/data/policies/$uuid/$coverageUuid'
    | '/app/data/companies/$uuid/debtor/coverages'
    | '/app/data/companies/$uuid/debtor/files'
    | '/app/data/companies/$uuid/debtor/insistences'
    | '/app/data/companies/$uuid/insured/coverages'
    | '/app/data/companies/$uuid/insured/files'
    | '/app/data/companies/$uuid/insured/insistences'
    | '/app/data/companies/$uuid/insured/policies'
    | '/app/data/companies/$uuid/debtor/'
    | '/app/data/companies/$uuid/insured/'
    | '/app/data/groups/$uuid/$policyUuid/$coverageUuid'
    | '/app/data/groups/$uuid/coverage/$coverageUuid'
    | '/app/data/companies/$uuid/debtor/coverages/$coverageUuid'
    | '/app/data/companies/$uuid/debtor/insistences/$coverageUuid'
    | '/app/data/companies/$uuid/insured/coverages/$coverageUuid'
    | '/app/data/companies/$uuid/insured/insistences/$coverageUuid'
    | '/app/data/companies/$uuid/insured/policies/$policyUuid'
    | '/app/data/companies/$uuid/debtor/coverages/$coverageUuid/'
    | '/app/data/companies/$uuid/debtor/insistences/$coverageUuid/'
    | '/app/data/companies/$uuid/insured/coverages/$coverageUuid/'
    | '/app/data/companies/$uuid/insured/insistences/$coverageUuid/'
    | '/app/data/companies/$uuid/insured/policies/$policyUuid/'
    | '/app/data/companies/$uuid/insured/policies/$policyUuid/$coverageUuid'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/app/analysis'
    | '/app/dashboard'
    | '/app/notifications'
    | '/app/users'
    | '/app'
    | '/session'
    | '/app/analysis/coverages'
    | '/app/data/coverages'
    | '/app/data/groups'
    | '/app/data/insistences'
    | '/app/data/policies'
    | '/app/settings/file-types'
    | '/app/settings/import-runs'
    | '/session/password-reset/link-sent'
    | '/app/data'
    | '/app/settings'
    | '/session/login'
    | '/session/password-reset'
    | '/app/data/companies/$uuid'
    | '/app/analysis/exposures'
    | '/app/analysis/insurers'
    | '/app/analysis/performance'
    | '/app/dashboard/$coverageUuid'
    | '/app/data/companies'
    | '/app/settings/trusted-devices'
    | '/session/login/2fa'
    | '/session/password-reset/$token'
    | '/app/data/companies/$uuid/edit'
    | '/app/analysis/coverages/$uuid'
    | '/app/data/coverages/$uuid'
    | '/app/data/groups/$uuid'
    | '/app/data/insistences/$coverageUuid'
    | '/app/data/policies/$uuid'
    | '/app/data/groups/$uuid/$policyUuid'
    | '/app/data/policies/$uuid/$coverageUuid'
    | '/app/data/companies/$uuid/debtor/coverages'
    | '/app/data/companies/$uuid/debtor/files'
    | '/app/data/companies/$uuid/debtor/insistences'
    | '/app/data/companies/$uuid/insured/coverages'
    | '/app/data/companies/$uuid/insured/files'
    | '/app/data/companies/$uuid/insured/insistences'
    | '/app/data/companies/$uuid/insured/policies'
    | '/app/data/companies/$uuid/debtor'
    | '/app/data/companies/$uuid/insured'
    | '/app/data/groups/$uuid/$policyUuid/$coverageUuid'
    | '/app/data/groups/$uuid/coverage/$coverageUuid'
    | '/app/data/companies/$uuid/debtor/coverages/$coverageUuid'
    | '/app/data/companies/$uuid/debtor/insistences/$coverageUuid'
    | '/app/data/companies/$uuid/insured/coverages/$coverageUuid'
    | '/app/data/companies/$uuid/insured/insistences/$coverageUuid'
    | '/app/data/companies/$uuid/insured/policies/$policyUuid'
    | '/app/data/companies/$uuid/insured/policies/$policyUuid/$coverageUuid'
  id:
    | '__root__'
    | '/'
    | '/app'
    | '/session'
    | '/app/analysis'
    | '/app/dashboard'
    | '/app/data'
    | '/app/notifications'
    | '/app/settings'
    | '/app/users'
    | '/session/password-reset'
    | '/app/'
    | '/session/'
    | '/app/analysis/coverages'
    | '/app/dashboard/$coverageUuid'
    | '/app/data/coverages'
    | '/app/data/groups'
    | '/app/data/insistences'
    | '/app/data/policies'
    | '/app/settings/file-types'
    | '/app/settings/import-runs'
    | '/session/password-reset/link-sent'
    | '/app/data/'
    | '/app/settings/'
    | '/session/login/'
    | '/session/password-reset/'
    | '/app/analysis/coverages/$uuid'
    | '/app/data/companies/$uuid'
    | '/app/data/coverages/$uuid'
    | '/app/data/groups/$uuid'
    | '/app/data/insistences/$coverageUuid'
    | '/app/data/policies/$uuid'
    | '/app/analysis/exposures/'
    | '/app/analysis/insurers/'
    | '/app/analysis/performance/'
    | '/app/dashboard/$coverageUuid/'
    | '/app/data/companies/'
    | '/app/settings/trusted-devices/'
    | '/session/login/2fa/'
    | '/session/password-reset/$token/'
    | '/app/data/companies/$uuid/(mainPage)'
    | '/app/data/companies/$uuid/edit'
    | '/app/analysis/coverages/$uuid/'
    | '/app/data/coverages/$uuid/'
    | '/app/data/groups/$uuid/'
    | '/app/data/insistences/$coverageUuid/'
    | '/app/data/policies/$uuid/'
    | '/app/data/companies/$uuid/(mainPage)/debtor'
    | '/app/data/companies/$uuid/(mainPage)/insured'
    | '/app/data/companies/$uuid/(mainPage)/'
    | '/app/data/groups/$uuid/$policyUuid/'
    | '/app/data/policies/$uuid/$coverageUuid/'
    | '/app/data/companies/$uuid/(mainPage)/debtor/coverages'
    | '/app/data/companies/$uuid/(mainPage)/debtor/files'
    | '/app/data/companies/$uuid/(mainPage)/debtor/insistences'
    | '/app/data/companies/$uuid/(mainPage)/insured/coverages'
    | '/app/data/companies/$uuid/(mainPage)/insured/files'
    | '/app/data/companies/$uuid/(mainPage)/insured/insistences'
    | '/app/data/companies/$uuid/(mainPage)/insured/policies'
    | '/app/data/companies/$uuid/(mainPage)/debtor/'
    | '/app/data/companies/$uuid/(mainPage)/insured/'
    | '/app/data/groups/$uuid/$policyUuid/$coverageUuid/'
    | '/app/data/groups/$uuid/coverage/$coverageUuid/'
    | '/app/data/companies/$uuid/(mainPage)/debtor/coverages/$coverageUuid'
    | '/app/data/companies/$uuid/(mainPage)/debtor/insistences/$coverageUuid'
    | '/app/data/companies/$uuid/(mainPage)/insured/coverages/$coverageUuid'
    | '/app/data/companies/$uuid/(mainPage)/insured/insistences/$coverageUuid'
    | '/app/data/companies/$uuid/(mainPage)/insured/policies/$policyUuid'
    | '/app/data/companies/$uuid/(mainPage)/debtor/coverages/$coverageUuid/'
    | '/app/data/companies/$uuid/(mainPage)/debtor/insistences/$coverageUuid/'
    | '/app/data/companies/$uuid/(mainPage)/insured/coverages/$coverageUuid/'
    | '/app/data/companies/$uuid/(mainPage)/insured/insistences/$coverageUuid/'
    | '/app/data/companies/$uuid/(mainPage)/insured/policies/$policyUuid/'
    | '/app/data/companies/$uuid/(mainPage)/insured/policies/$policyUuid/$coverageUuid/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRouteRoute: typeof AppRouteRouteWithChildren
  SessionRouteRoute: typeof SessionRouteRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/session': {
      id: '/session'
      path: '/session'
      fullPath: '/session'
      preLoaderRoute: typeof SessionRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app': {
      id: '/app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AppRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/session/': {
      id: '/session/'
      path: '/'
      fullPath: '/session/'
      preLoaderRoute: typeof SessionIndexRouteImport
      parentRoute: typeof SessionRouteRoute
    }
    '/app/': {
      id: '/app/'
      path: '/'
      fullPath: '/app/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/session/password-reset': {
      id: '/session/password-reset'
      path: '/password-reset'
      fullPath: '/session/password-reset'
      preLoaderRoute: typeof SessionPasswordResetRouteRouteImport
      parentRoute: typeof SessionRouteRoute
    }
    '/app/users': {
      id: '/app/users'
      path: '/users'
      fullPath: '/app/users'
      preLoaderRoute: typeof AppUsersRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/settings': {
      id: '/app/settings'
      path: '/settings'
      fullPath: '/app/settings'
      preLoaderRoute: typeof AppSettingsRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/notifications': {
      id: '/app/notifications'
      path: '/notifications'
      fullPath: '/app/notifications'
      preLoaderRoute: typeof AppNotificationsRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/data': {
      id: '/app/data'
      path: '/data'
      fullPath: '/app/data'
      preLoaderRoute: typeof AppDataRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/dashboard': {
      id: '/app/dashboard'
      path: '/dashboard'
      fullPath: '/app/dashboard'
      preLoaderRoute: typeof AppDashboardRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/analysis': {
      id: '/app/analysis'
      path: '/analysis'
      fullPath: '/app/analysis'
      preLoaderRoute: typeof AppAnalysisRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/session/password-reset/': {
      id: '/session/password-reset/'
      path: '/'
      fullPath: '/session/password-reset/'
      preLoaderRoute: typeof SessionPasswordResetIndexRouteImport
      parentRoute: typeof SessionPasswordResetRouteRoute
    }
    '/session/login/': {
      id: '/session/login/'
      path: '/login'
      fullPath: '/session/login'
      preLoaderRoute: typeof SessionLoginIndexRouteImport
      parentRoute: typeof SessionRouteRoute
    }
    '/app/settings/': {
      id: '/app/settings/'
      path: '/'
      fullPath: '/app/settings/'
      preLoaderRoute: typeof AppSettingsIndexRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/app/data/': {
      id: '/app/data/'
      path: '/'
      fullPath: '/app/data/'
      preLoaderRoute: typeof AppDataIndexRouteImport
      parentRoute: typeof AppDataRouteRoute
    }
    '/session/password-reset/link-sent': {
      id: '/session/password-reset/link-sent'
      path: '/link-sent'
      fullPath: '/session/password-reset/link-sent'
      preLoaderRoute: typeof SessionPasswordResetLinkSentRouteImport
      parentRoute: typeof SessionPasswordResetRouteRoute
    }
    '/app/settings/import-runs': {
      id: '/app/settings/import-runs'
      path: '/import-runs'
      fullPath: '/app/settings/import-runs'
      preLoaderRoute: typeof AppSettingsImportRunsRouteRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/app/settings/file-types': {
      id: '/app/settings/file-types'
      path: '/file-types'
      fullPath: '/app/settings/file-types'
      preLoaderRoute: typeof AppSettingsFileTypesRouteRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/app/data/policies': {
      id: '/app/data/policies'
      path: '/policies'
      fullPath: '/app/data/policies'
      preLoaderRoute: typeof AppDataPoliciesRouteRouteImport
      parentRoute: typeof AppDataRouteRoute
    }
    '/app/data/insistences': {
      id: '/app/data/insistences'
      path: '/insistences'
      fullPath: '/app/data/insistences'
      preLoaderRoute: typeof AppDataInsistencesRouteRouteImport
      parentRoute: typeof AppDataRouteRoute
    }
    '/app/data/groups': {
      id: '/app/data/groups'
      path: '/groups'
      fullPath: '/app/data/groups'
      preLoaderRoute: typeof AppDataGroupsRouteRouteImport
      parentRoute: typeof AppDataRouteRoute
    }
    '/app/data/coverages': {
      id: '/app/data/coverages'
      path: '/coverages'
      fullPath: '/app/data/coverages'
      preLoaderRoute: typeof AppDataCoveragesRouteRouteImport
      parentRoute: typeof AppDataRouteRoute
    }
    '/app/dashboard/$coverageUuid': {
      id: '/app/dashboard/$coverageUuid'
      path: '/$coverageUuid'
      fullPath: '/app/dashboard/$coverageUuid'
      preLoaderRoute: typeof AppDashboardCoverageUuidRouteRouteImport
      parentRoute: typeof AppDashboardRouteRoute
    }
    '/app/analysis/coverages': {
      id: '/app/analysis/coverages'
      path: '/coverages'
      fullPath: '/app/analysis/coverages'
      preLoaderRoute: typeof AppAnalysisCoveragesRouteRouteImport
      parentRoute: typeof AppAnalysisRouteRoute
    }
    '/session/password-reset/$token/': {
      id: '/session/password-reset/$token/'
      path: '/$token'
      fullPath: '/session/password-reset/$token'
      preLoaderRoute: typeof SessionPasswordResetTokenIndexRouteImport
      parentRoute: typeof SessionPasswordResetRouteRoute
    }
    '/session/login/2fa/': {
      id: '/session/login/2fa/'
      path: '/login/2fa'
      fullPath: '/session/login/2fa'
      preLoaderRoute: typeof SessionLogin2faIndexRouteImport
      parentRoute: typeof SessionRouteRoute
    }
    '/app/settings/trusted-devices/': {
      id: '/app/settings/trusted-devices/'
      path: '/trusted-devices'
      fullPath: '/app/settings/trusted-devices'
      preLoaderRoute: typeof AppSettingsTrustedDevicesIndexRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/app/data/companies/': {
      id: '/app/data/companies/'
      path: '/companies'
      fullPath: '/app/data/companies'
      preLoaderRoute: typeof AppDataCompaniesIndexRouteImport
      parentRoute: typeof AppDataRouteRoute
    }
    '/app/dashboard/$coverageUuid/': {
      id: '/app/dashboard/$coverageUuid/'
      path: '/'
      fullPath: '/app/dashboard/$coverageUuid/'
      preLoaderRoute: typeof AppDashboardCoverageUuidIndexRouteImport
      parentRoute: typeof AppDashboardCoverageUuidRouteRoute
    }
    '/app/analysis/performance/': {
      id: '/app/analysis/performance/'
      path: '/performance'
      fullPath: '/app/analysis/performance'
      preLoaderRoute: typeof AppAnalysisPerformanceIndexRouteImport
      parentRoute: typeof AppAnalysisRouteRoute
    }
    '/app/analysis/insurers/': {
      id: '/app/analysis/insurers/'
      path: '/insurers'
      fullPath: '/app/analysis/insurers'
      preLoaderRoute: typeof AppAnalysisInsurersIndexRouteImport
      parentRoute: typeof AppAnalysisRouteRoute
    }
    '/app/analysis/exposures/': {
      id: '/app/analysis/exposures/'
      path: '/exposures'
      fullPath: '/app/analysis/exposures'
      preLoaderRoute: typeof AppAnalysisExposuresIndexRouteImport
      parentRoute: typeof AppAnalysisRouteRoute
    }
    '/app/data/policies/$uuid': {
      id: '/app/data/policies/$uuid'
      path: '/$uuid'
      fullPath: '/app/data/policies/$uuid'
      preLoaderRoute: typeof AppDataPoliciesUuidRouteRouteImport
      parentRoute: typeof AppDataPoliciesRouteRoute
    }
    '/app/data/insistences/$coverageUuid': {
      id: '/app/data/insistences/$coverageUuid'
      path: '/$coverageUuid'
      fullPath: '/app/data/insistences/$coverageUuid'
      preLoaderRoute: typeof AppDataInsistencesCoverageUuidRouteRouteImport
      parentRoute: typeof AppDataInsistencesRouteRoute
    }
    '/app/data/groups/$uuid': {
      id: '/app/data/groups/$uuid'
      path: '/$uuid'
      fullPath: '/app/data/groups/$uuid'
      preLoaderRoute: typeof AppDataGroupsUuidRouteRouteImport
      parentRoute: typeof AppDataGroupsRouteRoute
    }
    '/app/data/coverages/$uuid': {
      id: '/app/data/coverages/$uuid'
      path: '/$uuid'
      fullPath: '/app/data/coverages/$uuid'
      preLoaderRoute: typeof AppDataCoveragesUuidRouteRouteImport
      parentRoute: typeof AppDataCoveragesRouteRoute
    }
    '/app/data/companies/$uuid': {
      id: '/app/data/companies/$uuid'
      path: '/companies/$uuid'
      fullPath: '/app/data/companies/$uuid'
      preLoaderRoute: typeof AppDataCompaniesUuidRouteRouteImport
      parentRoute: typeof AppDataRouteRoute
    }
    '/app/analysis/coverages/$uuid': {
      id: '/app/analysis/coverages/$uuid'
      path: '/$uuid'
      fullPath: '/app/analysis/coverages/$uuid'
      preLoaderRoute: typeof AppAnalysisCoveragesUuidRouteRouteImport
      parentRoute: typeof AppAnalysisCoveragesRouteRoute
    }
    '/app/data/policies/$uuid/': {
      id: '/app/data/policies/$uuid/'
      path: '/'
      fullPath: '/app/data/policies/$uuid/'
      preLoaderRoute: typeof AppDataPoliciesUuidIndexRouteImport
      parentRoute: typeof AppDataPoliciesUuidRouteRoute
    }
    '/app/data/insistences/$coverageUuid/': {
      id: '/app/data/insistences/$coverageUuid/'
      path: '/'
      fullPath: '/app/data/insistences/$coverageUuid/'
      preLoaderRoute: typeof AppDataInsistencesCoverageUuidIndexRouteImport
      parentRoute: typeof AppDataInsistencesCoverageUuidRouteRoute
    }
    '/app/data/groups/$uuid/': {
      id: '/app/data/groups/$uuid/'
      path: '/'
      fullPath: '/app/data/groups/$uuid/'
      preLoaderRoute: typeof AppDataGroupsUuidIndexRouteImport
      parentRoute: typeof AppDataGroupsUuidRouteRoute
    }
    '/app/data/coverages/$uuid/': {
      id: '/app/data/coverages/$uuid/'
      path: '/'
      fullPath: '/app/data/coverages/$uuid/'
      preLoaderRoute: typeof AppDataCoveragesUuidIndexRouteImport
      parentRoute: typeof AppDataCoveragesUuidRouteRoute
    }
    '/app/analysis/coverages/$uuid/': {
      id: '/app/analysis/coverages/$uuid/'
      path: '/'
      fullPath: '/app/analysis/coverages/$uuid/'
      preLoaderRoute: typeof AppAnalysisCoveragesUuidIndexRouteImport
      parentRoute: typeof AppAnalysisCoveragesUuidRouteRoute
    }
    '/app/data/companies/$uuid/edit': {
      id: '/app/data/companies/$uuid/edit'
      path: '/edit'
      fullPath: '/app/data/companies/$uuid/edit'
      preLoaderRoute: typeof AppDataCompaniesUuidEditRouteImport
      parentRoute: typeof AppDataCompaniesUuidRouteRoute
    }
    '/app/data/companies/$uuid/(mainPage)': {
      id: '/app/data/companies/$uuid/(mainPage)'
      path: ''
      fullPath: '/app/data/companies/$uuid'
      preLoaderRoute: typeof AppDataCompaniesUuidmainPageRouteRouteImport
      parentRoute: typeof AppDataCompaniesUuidRouteRoute
    }
    '/app/data/policies/$uuid/$coverageUuid/': {
      id: '/app/data/policies/$uuid/$coverageUuid/'
      path: '/$coverageUuid'
      fullPath: '/app/data/policies/$uuid/$coverageUuid'
      preLoaderRoute: typeof AppDataPoliciesUuidCoverageUuidIndexRouteImport
      parentRoute: typeof AppDataPoliciesUuidRouteRoute
    }
    '/app/data/groups/$uuid/$policyUuid/': {
      id: '/app/data/groups/$uuid/$policyUuid/'
      path: '/$policyUuid'
      fullPath: '/app/data/groups/$uuid/$policyUuid'
      preLoaderRoute: typeof AppDataGroupsUuidPolicyUuidIndexRouteImport
      parentRoute: typeof AppDataGroupsUuidRouteRoute
    }
    '/app/data/companies/$uuid/(mainPage)/': {
      id: '/app/data/companies/$uuid/(mainPage)/'
      path: '/'
      fullPath: '/app/data/companies/$uuid/'
      preLoaderRoute: typeof AppDataCompaniesUuidmainPageIndexRouteImport
      parentRoute: typeof AppDataCompaniesUuidmainPageRouteRoute
    }
    '/app/data/companies/$uuid/(mainPage)/insured': {
      id: '/app/data/companies/$uuid/(mainPage)/insured'
      path: '/insured'
      fullPath: '/app/data/companies/$uuid/insured'
      preLoaderRoute: typeof AppDataCompaniesUuidmainPageInsuredRouteRouteImport
      parentRoute: typeof AppDataCompaniesUuidmainPageRouteRoute
    }
    '/app/data/companies/$uuid/(mainPage)/debtor': {
      id: '/app/data/companies/$uuid/(mainPage)/debtor'
      path: '/debtor'
      fullPath: '/app/data/companies/$uuid/debtor'
      preLoaderRoute: typeof AppDataCompaniesUuidmainPageDebtorRouteRouteImport
      parentRoute: typeof AppDataCompaniesUuidmainPageRouteRoute
    }
    '/app/data/groups/$uuid/coverage/$coverageUuid/': {
      id: '/app/data/groups/$uuid/coverage/$coverageUuid/'
      path: '/coverage/$coverageUuid'
      fullPath: '/app/data/groups/$uuid/coverage/$coverageUuid'
      preLoaderRoute: typeof AppDataGroupsUuidCoverageCoverageUuidIndexRouteImport
      parentRoute: typeof AppDataGroupsUuidRouteRoute
    }
    '/app/data/groups/$uuid/$policyUuid/$coverageUuid/': {
      id: '/app/data/groups/$uuid/$policyUuid/$coverageUuid/'
      path: '/$policyUuid/$coverageUuid'
      fullPath: '/app/data/groups/$uuid/$policyUuid/$coverageUuid'
      preLoaderRoute: typeof AppDataGroupsUuidPolicyUuidCoverageUuidIndexRouteImport
      parentRoute: typeof AppDataGroupsUuidRouteRoute
    }
    '/app/data/companies/$uuid/(mainPage)/insured/': {
      id: '/app/data/companies/$uuid/(mainPage)/insured/'
      path: '/'
      fullPath: '/app/data/companies/$uuid/insured/'
      preLoaderRoute: typeof AppDataCompaniesUuidmainPageInsuredIndexRouteImport
      parentRoute: typeof AppDataCompaniesUuidmainPageInsuredRouteRoute
    }
    '/app/data/companies/$uuid/(mainPage)/debtor/': {
      id: '/app/data/companies/$uuid/(mainPage)/debtor/'
      path: '/'
      fullPath: '/app/data/companies/$uuid/debtor/'
      preLoaderRoute: typeof AppDataCompaniesUuidmainPageDebtorIndexRouteImport
      parentRoute: typeof AppDataCompaniesUuidmainPageDebtorRouteRoute
    }
    '/app/data/companies/$uuid/(mainPage)/insured/policies': {
      id: '/app/data/companies/$uuid/(mainPage)/insured/policies'
      path: '/policies'
      fullPath: '/app/data/companies/$uuid/insured/policies'
      preLoaderRoute: typeof AppDataCompaniesUuidmainPageInsuredPoliciesRouteRouteImport
      parentRoute: typeof AppDataCompaniesUuidmainPageInsuredRouteRoute
    }
    '/app/data/companies/$uuid/(mainPage)/insured/insistences': {
      id: '/app/data/companies/$uuid/(mainPage)/insured/insistences'
      path: '/insistences'
      fullPath: '/app/data/companies/$uuid/insured/insistences'
      preLoaderRoute: typeof AppDataCompaniesUuidmainPageInsuredInsistencesRouteRouteImport
      parentRoute: typeof AppDataCompaniesUuidmainPageInsuredRouteRoute
    }
    '/app/data/companies/$uuid/(mainPage)/insured/files': {
      id: '/app/data/companies/$uuid/(mainPage)/insured/files'
      path: '/files'
      fullPath: '/app/data/companies/$uuid/insured/files'
      preLoaderRoute: typeof AppDataCompaniesUuidmainPageInsuredFilesRouteRouteImport
      parentRoute: typeof AppDataCompaniesUuidmainPageInsuredRouteRoute
    }
    '/app/data/companies/$uuid/(mainPage)/insured/coverages': {
      id: '/app/data/companies/$uuid/(mainPage)/insured/coverages'
      path: '/coverages'
      fullPath: '/app/data/companies/$uuid/insured/coverages'
      preLoaderRoute: typeof AppDataCompaniesUuidmainPageInsuredCoveragesRouteRouteImport
      parentRoute: typeof AppDataCompaniesUuidmainPageInsuredRouteRoute
    }
    '/app/data/companies/$uuid/(mainPage)/debtor/insistences': {
      id: '/app/data/companies/$uuid/(mainPage)/debtor/insistences'
      path: '/insistences'
      fullPath: '/app/data/companies/$uuid/debtor/insistences'
      preLoaderRoute: typeof AppDataCompaniesUuidmainPageDebtorInsistencesRouteRouteImport
      parentRoute: typeof AppDataCompaniesUuidmainPageDebtorRouteRoute
    }
    '/app/data/companies/$uuid/(mainPage)/debtor/files': {
      id: '/app/data/companies/$uuid/(mainPage)/debtor/files'
      path: '/files'
      fullPath: '/app/data/companies/$uuid/debtor/files'
      preLoaderRoute: typeof AppDataCompaniesUuidmainPageDebtorFilesRouteRouteImport
      parentRoute: typeof AppDataCompaniesUuidmainPageDebtorRouteRoute
    }
    '/app/data/companies/$uuid/(mainPage)/debtor/coverages': {
      id: '/app/data/companies/$uuid/(mainPage)/debtor/coverages'
      path: '/coverages'
      fullPath: '/app/data/companies/$uuid/debtor/coverages'
      preLoaderRoute: typeof AppDataCompaniesUuidmainPageDebtorCoveragesRouteRouteImport
      parentRoute: typeof AppDataCompaniesUuidmainPageDebtorRouteRoute
    }
    '/app/data/companies/$uuid/(mainPage)/insured/policies/$policyUuid': {
      id: '/app/data/companies/$uuid/(mainPage)/insured/policies/$policyUuid'
      path: '/$policyUuid'
      fullPath: '/app/data/companies/$uuid/insured/policies/$policyUuid'
      preLoaderRoute: typeof AppDataCompaniesUuidmainPageInsuredPoliciesPolicyUuidRouteRouteImport
      parentRoute: typeof AppDataCompaniesUuidmainPageInsuredPoliciesRouteRoute
    }
    '/app/data/companies/$uuid/(mainPage)/insured/insistences/$coverageUuid': {
      id: '/app/data/companies/$uuid/(mainPage)/insured/insistences/$coverageUuid'
      path: '/$coverageUuid'
      fullPath: '/app/data/companies/$uuid/insured/insistences/$coverageUuid'
      preLoaderRoute: typeof AppDataCompaniesUuidmainPageInsuredInsistencesCoverageUuidRouteRouteImport
      parentRoute: typeof AppDataCompaniesUuidmainPageInsuredInsistencesRouteRoute
    }
    '/app/data/companies/$uuid/(mainPage)/insured/coverages/$coverageUuid': {
      id: '/app/data/companies/$uuid/(mainPage)/insured/coverages/$coverageUuid'
      path: '/$coverageUuid'
      fullPath: '/app/data/companies/$uuid/insured/coverages/$coverageUuid'
      preLoaderRoute: typeof AppDataCompaniesUuidmainPageInsuredCoveragesCoverageUuidRouteRouteImport
      parentRoute: typeof AppDataCompaniesUuidmainPageInsuredCoveragesRouteRoute
    }
    '/app/data/companies/$uuid/(mainPage)/debtor/insistences/$coverageUuid': {
      id: '/app/data/companies/$uuid/(mainPage)/debtor/insistences/$coverageUuid'
      path: '/$coverageUuid'
      fullPath: '/app/data/companies/$uuid/debtor/insistences/$coverageUuid'
      preLoaderRoute: typeof AppDataCompaniesUuidmainPageDebtorInsistencesCoverageUuidRouteRouteImport
      parentRoute: typeof AppDataCompaniesUuidmainPageDebtorInsistencesRouteRoute
    }
    '/app/data/companies/$uuid/(mainPage)/debtor/coverages/$coverageUuid': {
      id: '/app/data/companies/$uuid/(mainPage)/debtor/coverages/$coverageUuid'
      path: '/$coverageUuid'
      fullPath: '/app/data/companies/$uuid/debtor/coverages/$coverageUuid'
      preLoaderRoute: typeof AppDataCompaniesUuidmainPageDebtorCoveragesCoverageUuidRouteRouteImport
      parentRoute: typeof AppDataCompaniesUuidmainPageDebtorCoveragesRouteRoute
    }
    '/app/data/companies/$uuid/(mainPage)/insured/policies/$policyUuid/': {
      id: '/app/data/companies/$uuid/(mainPage)/insured/policies/$policyUuid/'
      path: '/'
      fullPath: '/app/data/companies/$uuid/insured/policies/$policyUuid/'
      preLoaderRoute: typeof AppDataCompaniesUuidmainPageInsuredPoliciesPolicyUuidIndexRouteImport
      parentRoute: typeof AppDataCompaniesUuidmainPageInsuredPoliciesPolicyUuidRouteRoute
    }
    '/app/data/companies/$uuid/(mainPage)/insured/insistences/$coverageUuid/': {
      id: '/app/data/companies/$uuid/(mainPage)/insured/insistences/$coverageUuid/'
      path: '/'
      fullPath: '/app/data/companies/$uuid/insured/insistences/$coverageUuid/'
      preLoaderRoute: typeof AppDataCompaniesUuidmainPageInsuredInsistencesCoverageUuidIndexRouteImport
      parentRoute: typeof AppDataCompaniesUuidmainPageInsuredInsistencesCoverageUuidRouteRoute
    }
    '/app/data/companies/$uuid/(mainPage)/insured/coverages/$coverageUuid/': {
      id: '/app/data/companies/$uuid/(mainPage)/insured/coverages/$coverageUuid/'
      path: '/'
      fullPath: '/app/data/companies/$uuid/insured/coverages/$coverageUuid/'
      preLoaderRoute: typeof AppDataCompaniesUuidmainPageInsuredCoveragesCoverageUuidIndexRouteImport
      parentRoute: typeof AppDataCompaniesUuidmainPageInsuredCoveragesCoverageUuidRouteRoute
    }
    '/app/data/companies/$uuid/(mainPage)/debtor/insistences/$coverageUuid/': {
      id: '/app/data/companies/$uuid/(mainPage)/debtor/insistences/$coverageUuid/'
      path: '/'
      fullPath: '/app/data/companies/$uuid/debtor/insistences/$coverageUuid/'
      preLoaderRoute: typeof AppDataCompaniesUuidmainPageDebtorInsistencesCoverageUuidIndexRouteImport
      parentRoute: typeof AppDataCompaniesUuidmainPageDebtorInsistencesCoverageUuidRouteRoute
    }
    '/app/data/companies/$uuid/(mainPage)/debtor/coverages/$coverageUuid/': {
      id: '/app/data/companies/$uuid/(mainPage)/debtor/coverages/$coverageUuid/'
      path: '/'
      fullPath: '/app/data/companies/$uuid/debtor/coverages/$coverageUuid/'
      preLoaderRoute: typeof AppDataCompaniesUuidmainPageDebtorCoveragesCoverageUuidIndexRouteImport
      parentRoute: typeof AppDataCompaniesUuidmainPageDebtorCoveragesCoverageUuidRouteRoute
    }
    '/app/data/companies/$uuid/(mainPage)/insured/policies/$policyUuid/$coverageUuid/': {
      id: '/app/data/companies/$uuid/(mainPage)/insured/policies/$policyUuid/$coverageUuid/'
      path: '/$coverageUuid'
      fullPath: '/app/data/companies/$uuid/insured/policies/$policyUuid/$coverageUuid'
      preLoaderRoute: typeof AppDataCompaniesUuidmainPageInsuredPoliciesPolicyUuidCoverageUuidIndexRouteImport
      parentRoute: typeof AppDataCompaniesUuidmainPageInsuredPoliciesPolicyUuidRouteRoute
    }
  }
}

interface AppAnalysisCoveragesUuidRouteRouteChildren {
  AppAnalysisCoveragesUuidIndexRoute: typeof AppAnalysisCoveragesUuidIndexRoute
}

const AppAnalysisCoveragesUuidRouteRouteChildren: AppAnalysisCoveragesUuidRouteRouteChildren =
  {
    AppAnalysisCoveragesUuidIndexRoute: AppAnalysisCoveragesUuidIndexRoute,
  }

const AppAnalysisCoveragesUuidRouteRouteWithChildren =
  AppAnalysisCoveragesUuidRouteRoute._addFileChildren(
    AppAnalysisCoveragesUuidRouteRouteChildren,
  )

interface AppAnalysisCoveragesRouteRouteChildren {
  AppAnalysisCoveragesUuidRouteRoute: typeof AppAnalysisCoveragesUuidRouteRouteWithChildren
}

const AppAnalysisCoveragesRouteRouteChildren: AppAnalysisCoveragesRouteRouteChildren =
  {
    AppAnalysisCoveragesUuidRouteRoute:
      AppAnalysisCoveragesUuidRouteRouteWithChildren,
  }

const AppAnalysisCoveragesRouteRouteWithChildren =
  AppAnalysisCoveragesRouteRoute._addFileChildren(
    AppAnalysisCoveragesRouteRouteChildren,
  )

interface AppAnalysisRouteRouteChildren {
  AppAnalysisCoveragesRouteRoute: typeof AppAnalysisCoveragesRouteRouteWithChildren
  AppAnalysisExposuresIndexRoute: typeof AppAnalysisExposuresIndexRoute
  AppAnalysisInsurersIndexRoute: typeof AppAnalysisInsurersIndexRoute
  AppAnalysisPerformanceIndexRoute: typeof AppAnalysisPerformanceIndexRoute
}

const AppAnalysisRouteRouteChildren: AppAnalysisRouteRouteChildren = {
  AppAnalysisCoveragesRouteRoute: AppAnalysisCoveragesRouteRouteWithChildren,
  AppAnalysisExposuresIndexRoute: AppAnalysisExposuresIndexRoute,
  AppAnalysisInsurersIndexRoute: AppAnalysisInsurersIndexRoute,
  AppAnalysisPerformanceIndexRoute: AppAnalysisPerformanceIndexRoute,
}

const AppAnalysisRouteRouteWithChildren =
  AppAnalysisRouteRoute._addFileChildren(AppAnalysisRouteRouteChildren)

interface AppDashboardCoverageUuidRouteRouteChildren {
  AppDashboardCoverageUuidIndexRoute: typeof AppDashboardCoverageUuidIndexRoute
}

const AppDashboardCoverageUuidRouteRouteChildren: AppDashboardCoverageUuidRouteRouteChildren =
  {
    AppDashboardCoverageUuidIndexRoute: AppDashboardCoverageUuidIndexRoute,
  }

const AppDashboardCoverageUuidRouteRouteWithChildren =
  AppDashboardCoverageUuidRouteRoute._addFileChildren(
    AppDashboardCoverageUuidRouteRouteChildren,
  )

interface AppDashboardRouteRouteChildren {
  AppDashboardCoverageUuidRouteRoute: typeof AppDashboardCoverageUuidRouteRouteWithChildren
}

const AppDashboardRouteRouteChildren: AppDashboardRouteRouteChildren = {
  AppDashboardCoverageUuidRouteRoute:
    AppDashboardCoverageUuidRouteRouteWithChildren,
}

const AppDashboardRouteRouteWithChildren =
  AppDashboardRouteRoute._addFileChildren(AppDashboardRouteRouteChildren)

interface AppDataCoveragesUuidRouteRouteChildren {
  AppDataCoveragesUuidIndexRoute: typeof AppDataCoveragesUuidIndexRoute
}

const AppDataCoveragesUuidRouteRouteChildren: AppDataCoveragesUuidRouteRouteChildren =
  {
    AppDataCoveragesUuidIndexRoute: AppDataCoveragesUuidIndexRoute,
  }

const AppDataCoveragesUuidRouteRouteWithChildren =
  AppDataCoveragesUuidRouteRoute._addFileChildren(
    AppDataCoveragesUuidRouteRouteChildren,
  )

interface AppDataCoveragesRouteRouteChildren {
  AppDataCoveragesUuidRouteRoute: typeof AppDataCoveragesUuidRouteRouteWithChildren
}

const AppDataCoveragesRouteRouteChildren: AppDataCoveragesRouteRouteChildren = {
  AppDataCoveragesUuidRouteRoute: AppDataCoveragesUuidRouteRouteWithChildren,
}

const AppDataCoveragesRouteRouteWithChildren =
  AppDataCoveragesRouteRoute._addFileChildren(
    AppDataCoveragesRouteRouteChildren,
  )

interface AppDataGroupsUuidRouteRouteChildren {
  AppDataGroupsUuidIndexRoute: typeof AppDataGroupsUuidIndexRoute
  AppDataGroupsUuidPolicyUuidIndexRoute: typeof AppDataGroupsUuidPolicyUuidIndexRoute
  AppDataGroupsUuidPolicyUuidCoverageUuidIndexRoute: typeof AppDataGroupsUuidPolicyUuidCoverageUuidIndexRoute
  AppDataGroupsUuidCoverageCoverageUuidIndexRoute: typeof AppDataGroupsUuidCoverageCoverageUuidIndexRoute
}

const AppDataGroupsUuidRouteRouteChildren: AppDataGroupsUuidRouteRouteChildren =
  {
    AppDataGroupsUuidIndexRoute: AppDataGroupsUuidIndexRoute,
    AppDataGroupsUuidPolicyUuidIndexRoute:
      AppDataGroupsUuidPolicyUuidIndexRoute,
    AppDataGroupsUuidPolicyUuidCoverageUuidIndexRoute:
      AppDataGroupsUuidPolicyUuidCoverageUuidIndexRoute,
    AppDataGroupsUuidCoverageCoverageUuidIndexRoute:
      AppDataGroupsUuidCoverageCoverageUuidIndexRoute,
  }

const AppDataGroupsUuidRouteRouteWithChildren =
  AppDataGroupsUuidRouteRoute._addFileChildren(
    AppDataGroupsUuidRouteRouteChildren,
  )

interface AppDataGroupsRouteRouteChildren {
  AppDataGroupsUuidRouteRoute: typeof AppDataGroupsUuidRouteRouteWithChildren
}

const AppDataGroupsRouteRouteChildren: AppDataGroupsRouteRouteChildren = {
  AppDataGroupsUuidRouteRoute: AppDataGroupsUuidRouteRouteWithChildren,
}

const AppDataGroupsRouteRouteWithChildren =
  AppDataGroupsRouteRoute._addFileChildren(AppDataGroupsRouteRouteChildren)

interface AppDataInsistencesCoverageUuidRouteRouteChildren {
  AppDataInsistencesCoverageUuidIndexRoute: typeof AppDataInsistencesCoverageUuidIndexRoute
}

const AppDataInsistencesCoverageUuidRouteRouteChildren: AppDataInsistencesCoverageUuidRouteRouteChildren =
  {
    AppDataInsistencesCoverageUuidIndexRoute:
      AppDataInsistencesCoverageUuidIndexRoute,
  }

const AppDataInsistencesCoverageUuidRouteRouteWithChildren =
  AppDataInsistencesCoverageUuidRouteRoute._addFileChildren(
    AppDataInsistencesCoverageUuidRouteRouteChildren,
  )

interface AppDataInsistencesRouteRouteChildren {
  AppDataInsistencesCoverageUuidRouteRoute: typeof AppDataInsistencesCoverageUuidRouteRouteWithChildren
}

const AppDataInsistencesRouteRouteChildren: AppDataInsistencesRouteRouteChildren =
  {
    AppDataInsistencesCoverageUuidRouteRoute:
      AppDataInsistencesCoverageUuidRouteRouteWithChildren,
  }

const AppDataInsistencesRouteRouteWithChildren =
  AppDataInsistencesRouteRoute._addFileChildren(
    AppDataInsistencesRouteRouteChildren,
  )

interface AppDataPoliciesUuidRouteRouteChildren {
  AppDataPoliciesUuidIndexRoute: typeof AppDataPoliciesUuidIndexRoute
  AppDataPoliciesUuidCoverageUuidIndexRoute: typeof AppDataPoliciesUuidCoverageUuidIndexRoute
}

const AppDataPoliciesUuidRouteRouteChildren: AppDataPoliciesUuidRouteRouteChildren =
  {
    AppDataPoliciesUuidIndexRoute: AppDataPoliciesUuidIndexRoute,
    AppDataPoliciesUuidCoverageUuidIndexRoute:
      AppDataPoliciesUuidCoverageUuidIndexRoute,
  }

const AppDataPoliciesUuidRouteRouteWithChildren =
  AppDataPoliciesUuidRouteRoute._addFileChildren(
    AppDataPoliciesUuidRouteRouteChildren,
  )

interface AppDataPoliciesRouteRouteChildren {
  AppDataPoliciesUuidRouteRoute: typeof AppDataPoliciesUuidRouteRouteWithChildren
}

const AppDataPoliciesRouteRouteChildren: AppDataPoliciesRouteRouteChildren = {
  AppDataPoliciesUuidRouteRoute: AppDataPoliciesUuidRouteRouteWithChildren,
}

const AppDataPoliciesRouteRouteWithChildren =
  AppDataPoliciesRouteRoute._addFileChildren(AppDataPoliciesRouteRouteChildren)

interface AppDataCompaniesUuidmainPageDebtorCoveragesCoverageUuidRouteRouteChildren {
  AppDataCompaniesUuidmainPageDebtorCoveragesCoverageUuidIndexRoute: typeof AppDataCompaniesUuidmainPageDebtorCoveragesCoverageUuidIndexRoute
}

const AppDataCompaniesUuidmainPageDebtorCoveragesCoverageUuidRouteRouteChildren: AppDataCompaniesUuidmainPageDebtorCoveragesCoverageUuidRouteRouteChildren =
  {
    AppDataCompaniesUuidmainPageDebtorCoveragesCoverageUuidIndexRoute:
      AppDataCompaniesUuidmainPageDebtorCoveragesCoverageUuidIndexRoute,
  }

const AppDataCompaniesUuidmainPageDebtorCoveragesCoverageUuidRouteRouteWithChildren =
  AppDataCompaniesUuidmainPageDebtorCoveragesCoverageUuidRouteRoute._addFileChildren(
    AppDataCompaniesUuidmainPageDebtorCoveragesCoverageUuidRouteRouteChildren,
  )

interface AppDataCompaniesUuidmainPageDebtorCoveragesRouteRouteChildren {
  AppDataCompaniesUuidmainPageDebtorCoveragesCoverageUuidRouteRoute: typeof AppDataCompaniesUuidmainPageDebtorCoveragesCoverageUuidRouteRouteWithChildren
}

const AppDataCompaniesUuidmainPageDebtorCoveragesRouteRouteChildren: AppDataCompaniesUuidmainPageDebtorCoveragesRouteRouteChildren =
  {
    AppDataCompaniesUuidmainPageDebtorCoveragesCoverageUuidRouteRoute:
      AppDataCompaniesUuidmainPageDebtorCoveragesCoverageUuidRouteRouteWithChildren,
  }

const AppDataCompaniesUuidmainPageDebtorCoveragesRouteRouteWithChildren =
  AppDataCompaniesUuidmainPageDebtorCoveragesRouteRoute._addFileChildren(
    AppDataCompaniesUuidmainPageDebtorCoveragesRouteRouteChildren,
  )

interface AppDataCompaniesUuidmainPageDebtorInsistencesCoverageUuidRouteRouteChildren {
  AppDataCompaniesUuidmainPageDebtorInsistencesCoverageUuidIndexRoute: typeof AppDataCompaniesUuidmainPageDebtorInsistencesCoverageUuidIndexRoute
}

const AppDataCompaniesUuidmainPageDebtorInsistencesCoverageUuidRouteRouteChildren: AppDataCompaniesUuidmainPageDebtorInsistencesCoverageUuidRouteRouteChildren =
  {
    AppDataCompaniesUuidmainPageDebtorInsistencesCoverageUuidIndexRoute:
      AppDataCompaniesUuidmainPageDebtorInsistencesCoverageUuidIndexRoute,
  }

const AppDataCompaniesUuidmainPageDebtorInsistencesCoverageUuidRouteRouteWithChildren =
  AppDataCompaniesUuidmainPageDebtorInsistencesCoverageUuidRouteRoute._addFileChildren(
    AppDataCompaniesUuidmainPageDebtorInsistencesCoverageUuidRouteRouteChildren,
  )

interface AppDataCompaniesUuidmainPageDebtorInsistencesRouteRouteChildren {
  AppDataCompaniesUuidmainPageDebtorInsistencesCoverageUuidRouteRoute: typeof AppDataCompaniesUuidmainPageDebtorInsistencesCoverageUuidRouteRouteWithChildren
}

const AppDataCompaniesUuidmainPageDebtorInsistencesRouteRouteChildren: AppDataCompaniesUuidmainPageDebtorInsistencesRouteRouteChildren =
  {
    AppDataCompaniesUuidmainPageDebtorInsistencesCoverageUuidRouteRoute:
      AppDataCompaniesUuidmainPageDebtorInsistencesCoverageUuidRouteRouteWithChildren,
  }

const AppDataCompaniesUuidmainPageDebtorInsistencesRouteRouteWithChildren =
  AppDataCompaniesUuidmainPageDebtorInsistencesRouteRoute._addFileChildren(
    AppDataCompaniesUuidmainPageDebtorInsistencesRouteRouteChildren,
  )

interface AppDataCompaniesUuidmainPageDebtorRouteRouteChildren {
  AppDataCompaniesUuidmainPageDebtorCoveragesRouteRoute: typeof AppDataCompaniesUuidmainPageDebtorCoveragesRouteRouteWithChildren
  AppDataCompaniesUuidmainPageDebtorFilesRouteRoute: typeof AppDataCompaniesUuidmainPageDebtorFilesRouteRoute
  AppDataCompaniesUuidmainPageDebtorInsistencesRouteRoute: typeof AppDataCompaniesUuidmainPageDebtorInsistencesRouteRouteWithChildren
  AppDataCompaniesUuidmainPageDebtorIndexRoute: typeof AppDataCompaniesUuidmainPageDebtorIndexRoute
}

const AppDataCompaniesUuidmainPageDebtorRouteRouteChildren: AppDataCompaniesUuidmainPageDebtorRouteRouteChildren =
  {
    AppDataCompaniesUuidmainPageDebtorCoveragesRouteRoute:
      AppDataCompaniesUuidmainPageDebtorCoveragesRouteRouteWithChildren,
    AppDataCompaniesUuidmainPageDebtorFilesRouteRoute:
      AppDataCompaniesUuidmainPageDebtorFilesRouteRoute,
    AppDataCompaniesUuidmainPageDebtorInsistencesRouteRoute:
      AppDataCompaniesUuidmainPageDebtorInsistencesRouteRouteWithChildren,
    AppDataCompaniesUuidmainPageDebtorIndexRoute:
      AppDataCompaniesUuidmainPageDebtorIndexRoute,
  }

const AppDataCompaniesUuidmainPageDebtorRouteRouteWithChildren =
  AppDataCompaniesUuidmainPageDebtorRouteRoute._addFileChildren(
    AppDataCompaniesUuidmainPageDebtorRouteRouteChildren,
  )

interface AppDataCompaniesUuidmainPageInsuredCoveragesCoverageUuidRouteRouteChildren {
  AppDataCompaniesUuidmainPageInsuredCoveragesCoverageUuidIndexRoute: typeof AppDataCompaniesUuidmainPageInsuredCoveragesCoverageUuidIndexRoute
}

const AppDataCompaniesUuidmainPageInsuredCoveragesCoverageUuidRouteRouteChildren: AppDataCompaniesUuidmainPageInsuredCoveragesCoverageUuidRouteRouteChildren =
  {
    AppDataCompaniesUuidmainPageInsuredCoveragesCoverageUuidIndexRoute:
      AppDataCompaniesUuidmainPageInsuredCoveragesCoverageUuidIndexRoute,
  }

const AppDataCompaniesUuidmainPageInsuredCoveragesCoverageUuidRouteRouteWithChildren =
  AppDataCompaniesUuidmainPageInsuredCoveragesCoverageUuidRouteRoute._addFileChildren(
    AppDataCompaniesUuidmainPageInsuredCoveragesCoverageUuidRouteRouteChildren,
  )

interface AppDataCompaniesUuidmainPageInsuredCoveragesRouteRouteChildren {
  AppDataCompaniesUuidmainPageInsuredCoveragesCoverageUuidRouteRoute: typeof AppDataCompaniesUuidmainPageInsuredCoveragesCoverageUuidRouteRouteWithChildren
}

const AppDataCompaniesUuidmainPageInsuredCoveragesRouteRouteChildren: AppDataCompaniesUuidmainPageInsuredCoveragesRouteRouteChildren =
  {
    AppDataCompaniesUuidmainPageInsuredCoveragesCoverageUuidRouteRoute:
      AppDataCompaniesUuidmainPageInsuredCoveragesCoverageUuidRouteRouteWithChildren,
  }

const AppDataCompaniesUuidmainPageInsuredCoveragesRouteRouteWithChildren =
  AppDataCompaniesUuidmainPageInsuredCoveragesRouteRoute._addFileChildren(
    AppDataCompaniesUuidmainPageInsuredCoveragesRouteRouteChildren,
  )

interface AppDataCompaniesUuidmainPageInsuredInsistencesCoverageUuidRouteRouteChildren {
  AppDataCompaniesUuidmainPageInsuredInsistencesCoverageUuidIndexRoute: typeof AppDataCompaniesUuidmainPageInsuredInsistencesCoverageUuidIndexRoute
}

const AppDataCompaniesUuidmainPageInsuredInsistencesCoverageUuidRouteRouteChildren: AppDataCompaniesUuidmainPageInsuredInsistencesCoverageUuidRouteRouteChildren =
  {
    AppDataCompaniesUuidmainPageInsuredInsistencesCoverageUuidIndexRoute:
      AppDataCompaniesUuidmainPageInsuredInsistencesCoverageUuidIndexRoute,
  }

const AppDataCompaniesUuidmainPageInsuredInsistencesCoverageUuidRouteRouteWithChildren =
  AppDataCompaniesUuidmainPageInsuredInsistencesCoverageUuidRouteRoute._addFileChildren(
    AppDataCompaniesUuidmainPageInsuredInsistencesCoverageUuidRouteRouteChildren,
  )

interface AppDataCompaniesUuidmainPageInsuredInsistencesRouteRouteChildren {
  AppDataCompaniesUuidmainPageInsuredInsistencesCoverageUuidRouteRoute: typeof AppDataCompaniesUuidmainPageInsuredInsistencesCoverageUuidRouteRouteWithChildren
}

const AppDataCompaniesUuidmainPageInsuredInsistencesRouteRouteChildren: AppDataCompaniesUuidmainPageInsuredInsistencesRouteRouteChildren =
  {
    AppDataCompaniesUuidmainPageInsuredInsistencesCoverageUuidRouteRoute:
      AppDataCompaniesUuidmainPageInsuredInsistencesCoverageUuidRouteRouteWithChildren,
  }

const AppDataCompaniesUuidmainPageInsuredInsistencesRouteRouteWithChildren =
  AppDataCompaniesUuidmainPageInsuredInsistencesRouteRoute._addFileChildren(
    AppDataCompaniesUuidmainPageInsuredInsistencesRouteRouteChildren,
  )

interface AppDataCompaniesUuidmainPageInsuredPoliciesPolicyUuidRouteRouteChildren {
  AppDataCompaniesUuidmainPageInsuredPoliciesPolicyUuidIndexRoute: typeof AppDataCompaniesUuidmainPageInsuredPoliciesPolicyUuidIndexRoute
  AppDataCompaniesUuidmainPageInsuredPoliciesPolicyUuidCoverageUuidIndexRoute: typeof AppDataCompaniesUuidmainPageInsuredPoliciesPolicyUuidCoverageUuidIndexRoute
}

const AppDataCompaniesUuidmainPageInsuredPoliciesPolicyUuidRouteRouteChildren: AppDataCompaniesUuidmainPageInsuredPoliciesPolicyUuidRouteRouteChildren =
  {
    AppDataCompaniesUuidmainPageInsuredPoliciesPolicyUuidIndexRoute:
      AppDataCompaniesUuidmainPageInsuredPoliciesPolicyUuidIndexRoute,
    AppDataCompaniesUuidmainPageInsuredPoliciesPolicyUuidCoverageUuidIndexRoute:
      AppDataCompaniesUuidmainPageInsuredPoliciesPolicyUuidCoverageUuidIndexRoute,
  }

const AppDataCompaniesUuidmainPageInsuredPoliciesPolicyUuidRouteRouteWithChildren =
  AppDataCompaniesUuidmainPageInsuredPoliciesPolicyUuidRouteRoute._addFileChildren(
    AppDataCompaniesUuidmainPageInsuredPoliciesPolicyUuidRouteRouteChildren,
  )

interface AppDataCompaniesUuidmainPageInsuredPoliciesRouteRouteChildren {
  AppDataCompaniesUuidmainPageInsuredPoliciesPolicyUuidRouteRoute: typeof AppDataCompaniesUuidmainPageInsuredPoliciesPolicyUuidRouteRouteWithChildren
}

const AppDataCompaniesUuidmainPageInsuredPoliciesRouteRouteChildren: AppDataCompaniesUuidmainPageInsuredPoliciesRouteRouteChildren =
  {
    AppDataCompaniesUuidmainPageInsuredPoliciesPolicyUuidRouteRoute:
      AppDataCompaniesUuidmainPageInsuredPoliciesPolicyUuidRouteRouteWithChildren,
  }

const AppDataCompaniesUuidmainPageInsuredPoliciesRouteRouteWithChildren =
  AppDataCompaniesUuidmainPageInsuredPoliciesRouteRoute._addFileChildren(
    AppDataCompaniesUuidmainPageInsuredPoliciesRouteRouteChildren,
  )

interface AppDataCompaniesUuidmainPageInsuredRouteRouteChildren {
  AppDataCompaniesUuidmainPageInsuredCoveragesRouteRoute: typeof AppDataCompaniesUuidmainPageInsuredCoveragesRouteRouteWithChildren
  AppDataCompaniesUuidmainPageInsuredFilesRouteRoute: typeof AppDataCompaniesUuidmainPageInsuredFilesRouteRoute
  AppDataCompaniesUuidmainPageInsuredInsistencesRouteRoute: typeof AppDataCompaniesUuidmainPageInsuredInsistencesRouteRouteWithChildren
  AppDataCompaniesUuidmainPageInsuredPoliciesRouteRoute: typeof AppDataCompaniesUuidmainPageInsuredPoliciesRouteRouteWithChildren
  AppDataCompaniesUuidmainPageInsuredIndexRoute: typeof AppDataCompaniesUuidmainPageInsuredIndexRoute
}

const AppDataCompaniesUuidmainPageInsuredRouteRouteChildren: AppDataCompaniesUuidmainPageInsuredRouteRouteChildren =
  {
    AppDataCompaniesUuidmainPageInsuredCoveragesRouteRoute:
      AppDataCompaniesUuidmainPageInsuredCoveragesRouteRouteWithChildren,
    AppDataCompaniesUuidmainPageInsuredFilesRouteRoute:
      AppDataCompaniesUuidmainPageInsuredFilesRouteRoute,
    AppDataCompaniesUuidmainPageInsuredInsistencesRouteRoute:
      AppDataCompaniesUuidmainPageInsuredInsistencesRouteRouteWithChildren,
    AppDataCompaniesUuidmainPageInsuredPoliciesRouteRoute:
      AppDataCompaniesUuidmainPageInsuredPoliciesRouteRouteWithChildren,
    AppDataCompaniesUuidmainPageInsuredIndexRoute:
      AppDataCompaniesUuidmainPageInsuredIndexRoute,
  }

const AppDataCompaniesUuidmainPageInsuredRouteRouteWithChildren =
  AppDataCompaniesUuidmainPageInsuredRouteRoute._addFileChildren(
    AppDataCompaniesUuidmainPageInsuredRouteRouteChildren,
  )

interface AppDataCompaniesUuidmainPageRouteRouteChildren {
  AppDataCompaniesUuidmainPageDebtorRouteRoute: typeof AppDataCompaniesUuidmainPageDebtorRouteRouteWithChildren
  AppDataCompaniesUuidmainPageInsuredRouteRoute: typeof AppDataCompaniesUuidmainPageInsuredRouteRouteWithChildren
  AppDataCompaniesUuidmainPageIndexRoute: typeof AppDataCompaniesUuidmainPageIndexRoute
}

const AppDataCompaniesUuidmainPageRouteRouteChildren: AppDataCompaniesUuidmainPageRouteRouteChildren =
  {
    AppDataCompaniesUuidmainPageDebtorRouteRoute:
      AppDataCompaniesUuidmainPageDebtorRouteRouteWithChildren,
    AppDataCompaniesUuidmainPageInsuredRouteRoute:
      AppDataCompaniesUuidmainPageInsuredRouteRouteWithChildren,
    AppDataCompaniesUuidmainPageIndexRoute:
      AppDataCompaniesUuidmainPageIndexRoute,
  }

const AppDataCompaniesUuidmainPageRouteRouteWithChildren =
  AppDataCompaniesUuidmainPageRouteRoute._addFileChildren(
    AppDataCompaniesUuidmainPageRouteRouteChildren,
  )

interface AppDataCompaniesUuidRouteRouteChildren {
  AppDataCompaniesUuidmainPageRouteRoute: typeof AppDataCompaniesUuidmainPageRouteRouteWithChildren
  AppDataCompaniesUuidEditRoute: typeof AppDataCompaniesUuidEditRoute
}

const AppDataCompaniesUuidRouteRouteChildren: AppDataCompaniesUuidRouteRouteChildren =
  {
    AppDataCompaniesUuidmainPageRouteRoute:
      AppDataCompaniesUuidmainPageRouteRouteWithChildren,
    AppDataCompaniesUuidEditRoute: AppDataCompaniesUuidEditRoute,
  }

const AppDataCompaniesUuidRouteRouteWithChildren =
  AppDataCompaniesUuidRouteRoute._addFileChildren(
    AppDataCompaniesUuidRouteRouteChildren,
  )

interface AppDataRouteRouteChildren {
  AppDataCoveragesRouteRoute: typeof AppDataCoveragesRouteRouteWithChildren
  AppDataGroupsRouteRoute: typeof AppDataGroupsRouteRouteWithChildren
  AppDataInsistencesRouteRoute: typeof AppDataInsistencesRouteRouteWithChildren
  AppDataPoliciesRouteRoute: typeof AppDataPoliciesRouteRouteWithChildren
  AppDataIndexRoute: typeof AppDataIndexRoute
  AppDataCompaniesUuidRouteRoute: typeof AppDataCompaniesUuidRouteRouteWithChildren
  AppDataCompaniesIndexRoute: typeof AppDataCompaniesIndexRoute
}

const AppDataRouteRouteChildren: AppDataRouteRouteChildren = {
  AppDataCoveragesRouteRoute: AppDataCoveragesRouteRouteWithChildren,
  AppDataGroupsRouteRoute: AppDataGroupsRouteRouteWithChildren,
  AppDataInsistencesRouteRoute: AppDataInsistencesRouteRouteWithChildren,
  AppDataPoliciesRouteRoute: AppDataPoliciesRouteRouteWithChildren,
  AppDataIndexRoute: AppDataIndexRoute,
  AppDataCompaniesUuidRouteRoute: AppDataCompaniesUuidRouteRouteWithChildren,
  AppDataCompaniesIndexRoute: AppDataCompaniesIndexRoute,
}

const AppDataRouteRouteWithChildren = AppDataRouteRoute._addFileChildren(
  AppDataRouteRouteChildren,
)

interface AppSettingsRouteRouteChildren {
  AppSettingsFileTypesRouteRoute: typeof AppSettingsFileTypesRouteRoute
  AppSettingsImportRunsRouteRoute: typeof AppSettingsImportRunsRouteRoute
  AppSettingsIndexRoute: typeof AppSettingsIndexRoute
  AppSettingsTrustedDevicesIndexRoute: typeof AppSettingsTrustedDevicesIndexRoute
}

const AppSettingsRouteRouteChildren: AppSettingsRouteRouteChildren = {
  AppSettingsFileTypesRouteRoute: AppSettingsFileTypesRouteRoute,
  AppSettingsImportRunsRouteRoute: AppSettingsImportRunsRouteRoute,
  AppSettingsIndexRoute: AppSettingsIndexRoute,
  AppSettingsTrustedDevicesIndexRoute: AppSettingsTrustedDevicesIndexRoute,
}

const AppSettingsRouteRouteWithChildren =
  AppSettingsRouteRoute._addFileChildren(AppSettingsRouteRouteChildren)

interface AppRouteRouteChildren {
  AppAnalysisRouteRoute: typeof AppAnalysisRouteRouteWithChildren
  AppDashboardRouteRoute: typeof AppDashboardRouteRouteWithChildren
  AppDataRouteRoute: typeof AppDataRouteRouteWithChildren
  AppNotificationsRouteRoute: typeof AppNotificationsRouteRoute
  AppSettingsRouteRoute: typeof AppSettingsRouteRouteWithChildren
  AppUsersRouteRoute: typeof AppUsersRouteRoute
  AppIndexRoute: typeof AppIndexRoute
}

const AppRouteRouteChildren: AppRouteRouteChildren = {
  AppAnalysisRouteRoute: AppAnalysisRouteRouteWithChildren,
  AppDashboardRouteRoute: AppDashboardRouteRouteWithChildren,
  AppDataRouteRoute: AppDataRouteRouteWithChildren,
  AppNotificationsRouteRoute: AppNotificationsRouteRoute,
  AppSettingsRouteRoute: AppSettingsRouteRouteWithChildren,
  AppUsersRouteRoute: AppUsersRouteRoute,
  AppIndexRoute: AppIndexRoute,
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(
  AppRouteRouteChildren,
)

interface SessionPasswordResetRouteRouteChildren {
  SessionPasswordResetLinkSentRoute: typeof SessionPasswordResetLinkSentRoute
  SessionPasswordResetIndexRoute: typeof SessionPasswordResetIndexRoute
  SessionPasswordResetTokenIndexRoute: typeof SessionPasswordResetTokenIndexRoute
}

const SessionPasswordResetRouteRouteChildren: SessionPasswordResetRouteRouteChildren =
  {
    SessionPasswordResetLinkSentRoute: SessionPasswordResetLinkSentRoute,
    SessionPasswordResetIndexRoute: SessionPasswordResetIndexRoute,
    SessionPasswordResetTokenIndexRoute: SessionPasswordResetTokenIndexRoute,
  }

const SessionPasswordResetRouteRouteWithChildren =
  SessionPasswordResetRouteRoute._addFileChildren(
    SessionPasswordResetRouteRouteChildren,
  )

interface SessionRouteRouteChildren {
  SessionPasswordResetRouteRoute: typeof SessionPasswordResetRouteRouteWithChildren
  SessionIndexRoute: typeof SessionIndexRoute
  SessionLoginIndexRoute: typeof SessionLoginIndexRoute
  SessionLogin2faIndexRoute: typeof SessionLogin2faIndexRoute
}

const SessionRouteRouteChildren: SessionRouteRouteChildren = {
  SessionPasswordResetRouteRoute: SessionPasswordResetRouteRouteWithChildren,
  SessionIndexRoute: SessionIndexRoute,
  SessionLoginIndexRoute: SessionLoginIndexRoute,
  SessionLogin2faIndexRoute: SessionLogin2faIndexRoute,
}

const SessionRouteRouteWithChildren = SessionRouteRoute._addFileChildren(
  SessionRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRouteRoute: AppRouteRouteWithChildren,
  SessionRouteRoute: SessionRouteRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
